{
  "cta": {
    "create-a-chart": "Een tabel maken"
  },
  "breadcrumb": {
    "dashboard": "Dashboard",
    "products": "Producten",
    "charts": "Tabellen",
    "restock-alerts": "Meldingen voor voorraadaanvulling",
    "settings": "Instellingen",
    "setting": "Instellingen",
    "account": "Account",
    "personal": "Persoonlijk",
    "organization": "Organisatie",
    "appearance": "Uiterlijk",
    "themes": "Thema's",
    "button": "Knop",
    "font-family": "Lettertypefamilie",
    "uploads": "Uploads",
    "dimensions": "Afmetingen",
    "notifications": "Meldingen",
    "analytic": "Analyse",
    "analytics": "Analyse",
    "restock-settings": "Instellingen voor voorraadaanvulling",
    "inventory": "Meldingen voor voorraadaanvulling",
    "plans": "Abonnementen",
    "billing": "Facturering",
    "overview": "Overzicht",
    "plan-and-usage": "Abonnement en gebruik",
    "chart-views": "Tabelweergaven",
    "add-to-cart": "Toevoegen aan winkelwagen",
    "buy-now": "Nu kopen",
    "size-recommendations": "Maataanbevelingen",
    "stock-notifications": "Voorraadmeldingen",
    "reports": "Rapporten",
    "comparison": "Vergelijking",
    "images": "Uploads",
    "sidekick": "Sidekick",
    "import": "Import",
    "contact": "Contact",
    "help-articles": "Helpartikelen",
    "new": "Nieuw"
  },
  "page": {
    "dashboard": {
      "table-style-chart": "Tabel in roosterstijl",
      "build-a-fully-custom-grid-with-complete-control-over-every-row-column-and-measurement-unit-best-for-complex-sizing-across-multiple-regions": "Bouw een volledig aangepast rooster met volledige controle over elke rij, kolom en meeteenheid. Ideaal voor complexe maatvoering in meerdere regio's.",
      "create-table-chart": "Roostertabel maken",
      "create-from-product": "Maken vanuit product",
      "start-from-template": "Beginnen met een sjabloon",
      "browse-templates": "Sjablonen bekijken",
      "create-with-drag-drop": "Maken met slepen en neerzetten",
      "creating": "Bezig met maken",
      "how-would-you-like-to-build-your-chart": "Hoe wil je<br /><span class=\"text-primary\">je maattabel bouwen?</span>",
      "choose-a-method-below-or-tell-us-what-you-sell-and-we-ll-highlight-the-best-fit": "Kies hieronder een methode, of vertel ons wat je verkoopt en wij lichten de beste optie uit.",
      "fastest-setup-2-min": "Snelste instelling · ~2 min",
      "used-by-1000-merchants": "Gebruikt door meer dan 1000 verkopers",
      "auto-generate-a-matching-size-chart-directly-from-your-existing-shopify-variant-data-no-manual-entry-it-reads-your-product-and-fills-the-table-for-you": "Genereer automatisch een passende maattabel rechtstreeks vanuit je bestaande Shopify-variantgegevens. Geen handmatige invoer nodig — het leest je product en vult de tabel voor je in",
      "garment-templates-ready-to-use": "Kledingsjablonen die klaar zijn voor gebruik",
      "pick-from-ready-made-templates-for-tops-bottoms-shoes-belts-bags-and-more-customise-any-field-after-great-for-getting-started-in-under-a-minute": "Kies uit kant-en-klare sjablonen voor bovenkleding, onderkleding, schoenen, riemen, tassen en meer. Pas daarna elk veld aan — ideaal om binnen een minuut aan de slag te gaan.",
      "drag-drop-no-data-needed-upfront": "Slepen en neerzetten · geen gegevens vooraf nodig",
      "upload-any-product-image-and-annotate-measurements-directly-on-it-with-drag-drop-pins-ideal-for-shoes-bags-accessories-and-equipment": "Upload een willekeurige productafbeelding en geef er metingen op aan met sleeppunten. Ideaal voor schoenen, tassen, accessoires en uitrusting.",
      "excel-like": "Excel-achtig",
      "auto-generated": "Automatisch gegenereerd",
      "annotate-on-image": "Aangeven op afbeelding",
      "what-are-you-selling": "Wat verkoop je?",
      "category-clothing-apparel": "Kleding en confectie",
      "category-shoes": "Schoenen",
      "category-accessories": "Accessoires",
      "category-other": "Iets anders",
      "start-date": "Startdatum",
      "end-date": "Einddatum"
    },
    "products": {
      "select-a-product-to-create-or-link-a-size-chart-for-that-product": "Selecteer een product om een maattabel voor dat product te maken of te koppelen.",
      "product-name": "Productnaam",
      "best-selling": "Bestsellers",
      "most-selling": "Meest verkocht eerst",
      "least-selling": "Minst verkocht",
      "best-selling-unavailable": "Verkoopgegevens zijn nog niet beschikbaar, dus producten worden getoond op laatste update.",
      "chart-attached": "Tabel toegevoegd",
      "shopify-status": "Shopify-status",
      "search-placeholder": "Zoek in alle producten...",
      "vendors": "Leveranciers",
      "tags": "Tags",
      "statuses": "Statussen",
      "collections": "Collecties",
      "types": "Types",
      "add-filter": "Filter toevoegen",
      "categories": "Categorieën",
      "search-and-filter-tooltip": "Zoeken en filteren (F)",
      "import-selection": "Selectie importeren",
      "failed-import-measurements": "Importeren van metingen mislukt",
      "product-updated": "Product succesvol bijgewerkt"
    },
    "charts": {
      "create-edit-duplicate-or-link-a-chart-to-a-product-from-here": "Maak, bewerk, dupliceer of koppel hier een tabel aan een product.",
      "chart-name": "Tabelnaam",
      "chart-type": "Tabeltype",
      "linked-to": "Gekoppeld aan",
      "last-updated": "Laatst bijgewerkt",
      "delete-x-charts": "{{ x }} tabellen verwijderen",
      "assigned-products": "Toegewezen producten",
      "failed-to-fetch-products-data": "Productgegevens konden niet worden opgehaald",
      "delete-chart": "Tabel verwijderen",
      "are-you-sure-you-want-to-delete-selected-chart-s-all-products-using-chart-s-will-be-unassigned": "Weet je zeker dat je de geselecteerde tabel(len) wilt verwijderen? Alle producten die deze tabel(len) gebruiken, worden niet meer toegewezen.",
      "successfully-deleted-chart-s": "Tabel(len) succesvol verwijderd!",
      "successfully-duplicated-chart": "Tabel succesvol gedupliceerd!",
      "turn-this-into-a-conversion-chart": "Zet dit om naar een conversietabel",
      "upgradable-tooltip": "Deze roostertabel lijkt op een gestructureerde maattabel en kan worden geconverteerd.",
      "convert-to-size-chart": "Omzetten naar maattabel",
      "convertibility-failed": "We konden niet controleren welke roostertabellen kunnen worden geconverteerd.",
      "convert": {
        "table-chart-info-callout": "Deze roostertabel kan worden geüpgraded naar een slimme maattabel",
        "table-chart-info-callout-message": "Bij conversie wordt je rooster gekoppeld aan afmetingen uit je bibliotheek, wat een visuele meetgids en modelinformatie ontsluit die een gewone tabel niet kan tonen.",
        "successfully-converted": "Succesvol geconverteerd naar een maattabel!",
        "detected-sizes": "Gedetecteerde maten",
        "at-least-two-sizes-are-needed": "Er zijn minstens twee maten nodig om deze tabel te converteren.",
        "unnamed-row": "Naamloze rij",
        "ignore-this-row": "Deze rij negeren",
        "this-dimension-is-already-mapped": "Deze afmeting is al gekoppeld aan een andere rij.",
        "map-at-least-one-row": "Koppel minstens één rij aan een afmeting.",
        "finish-your-measurement-guide": "Voltooi je meetgids",
        "measurement-points-without-values": "Meetpunten zonder waarden ({{ x }})",
        "fill-them-in-after-converting": "Je geselecteerde afbeelding toont ze, maar je tabel had geen dergelijke rijen. Vul hun waarden in na conversie.",
        "measurements-without-points": "Metingen zonder een punt op je afbeelding ({{ x }})",
        "no-image-selected-yet": "Nog geen afbeelding geselecteerd",
        "upload-an-image-then-drag-points": "Upload een afbeelding en sleep vervolgens de meetpunten erop.",
        "your-image-has-no-measurement-points": "Je geselecteerde afbeelding heeft nog geen meetpunten",
        "drag-measurement-points-onto-the-image": "Sleep hun meetpunten op de afbeelding zodat kopers kunnen zien waar ze moeten meten.",
        "plus-x-more": "+{{ x }} meer",
        "satisfied-button": "Ziet er goed uit — maak dit mijn actieve tabel",
        "satisfied-explanation": "Je roostertabel wordt niet meer gepubliceerd, deze tabel wordt gepubliceerd en de toegewezen producten worden overgezet.",
        "satisfied-success": "Deze tabel is nu actief!",
        "step-x-of-y": "Stap {{ x }} van {{ y }}",
        "choose-product-type": "Kies producttype",
        "well-match-your-table-to-a-visual": "We koppelen je tabel aan het juiste visuele product.",
        "save-settings": "Instellingen opslaan",
        "review-table-mapping": "Tabelkoppeling controleren",
        "confirm-the-rows-to-convert": "Bevestig de rijen die we moeten converteren.",
        "existing-table": "Bestaande tabel",
        "sizes": "Maten",
        "row": "Rij",
        "column": "Kolom",
        "x-rows-need-review": "{{ x }} rijen moeten worden gecontroleerd",
        "couldnt-match-this-row": "We konden deze meting niet automatisch koppelen",
        "change-match": "Koppeling wijzigen",
        "view-values": "Waarden bekijken",
        "hide-values": "Waarden verbergen",
        "matched-automatically": "Automatisch gekoppeld",
        "edit-matches": "Koppelingen bewerken",
        "create-preview": "Voorbeeld maken",
        "preview-ready": "Voorbeeld gereed",
        "open-it-to-finish-the-missing-values": "Open het om de ontbrekende waarden aan te vullen.",
        "converted": "Geconverteerd",
        "open-preview": "Voorbeeld openen",
        "you-can-add-them-in-the-preview": "Je kunt ze toevoegen in het voorbeeld."
      }
    },
    "inventory": {
      "collect-emails-and-send-automatic-back-in-stock-notifications-setup-notification": "Verzamel e-mailadressen en verstuur automatische meldingen bij herbevoorrading. Melding instellen",
      "here": "hier",
      "successfully-export-inventory-data": "Voorraadgegevens succesvol geëxporteerd",
      "active-your-store-inventory-notification-feature": "Activeer de voorraadmeldingsfunctie van je winkel",
      "in-order-to-receive-users-subscribed-for-your-products": "om gebruikers te ontvangen die zich hebben aangemeld voor je producten.",
      "your-subscribers-have-been-delegeted-to-your": "Je abonnees zijn overgedragen aan je"
    },
    "setting": {
      "storefront-popup-preview": "Voorbeeld van winkelpop-up",
      "add-to-cart": "Toevoegen aan winkelwagen",
      "buy-now": "Nu kopen",
      "sans-serif": "Schreefloos",
      "serif": "Schreef",
      "email-body-is-required": "E-mailtekst is verplicht",
      "list": "Lijst",
      "category-image": "Categorieafbeelding",
      "pay-over-usage-cost": "Overschrijdingskosten betalen",
      "over-usage-count": "Aantal overschrijdingen",
      "over-usage-cost": "Overschrijdingskosten",
      "x-usages": "{{ x }} keer gebruikt",
      "failed-to-pay-over-usage-cost": "Betalen van overschrijdingskosten mislukt",
      "manage-your-personal-information-and-account-perferences": "Beheer je persoonlijke gegevens en accountvoorkeuren.",
      "manage-your-organization-contact-information-and-address": "Beheer de contactgegevens en het adres van je organisatie.",
      "manage-your-billing-overview": "Bekijk je factureringsgegevens, abonnement en betalingsinformatie.",
      "manage-your-plan-and-usage": "Bekijk je huidige abonnement en gebruikslimieten.",
      "manage-your-measurement-dimensions": "Beheer de maatafmetingen die in je maattabellen worden gebruikt.",
      "dimension-translations": "Vertalingen voor de winkel",
      "dimension-translations-description": "Voer het label in dat kopers moeten zien voor elke ondersteunde winkeltaal. Laat leeg om de standaardnaam te gebruiken.",
      "default-dimension-name": "Standaard afmetingsnaam",
      "dimension-name-description": "Wordt gebruikt in het hele dashboard en als terugvaloptie voor de winkel wanneer er geen vertaling is opgegeven.",
      "storefront-label": "Winkellabel",
      "naming": "Benaming",
      "affecting-data": "Betrokken gegevens",
      "first-name-is-required": "Voornaam is verplicht",
      "last-name-is-required": "Achternaam is verplicht",
      "subscribed-for-our-latest-news-exclusive-offers-and-exciting-updates": "Aangemeld voor ons laatste nieuws, exclusieve aanbiedingen en interessante updates.",
      "contact-information": "Contactgegevens",
      "contact-name": "Contactnaam",
      "contact-name-is-required": "Contactnaam is verplicht!",
      "contact-email": "Contact-e-mailadres",
      "contact-email-is-required": "Contact-e-mailadres is verplicht!",
      "contact-email-is-invalid": "Contact-e-mailadres is ongeldig!",
      "company-organization-name": "Bedrijfs-/organisatienaam",
      "company-organization-name-is-required": "Bedrijfs-/organisatienaam is verplicht",
      "street-address": "Straatadres",
      "street-address-is-required": "Straatadres is verplicht!",
      "street-address-2": "Adresregel 2",
      "city": "Stad",
      "city-is-required": "Stad is verplicht!",
      "state-province-region": "Staat/Provincie/Regio",
      "state-province-region-is-required": "Staat/Provincie/Regio is verplicht!",
      "country": "Land",
      "country-is-required": "Land is verplicht!",
      "postal-zip-code": "Postcode",
      "postal-zip-code-is-required": "Postcode is verplicht!",
      "themes": "Thema's",
      "customise-your-app-look-choose-a-colour-that-best-represents-your-brand": "Pas het uiterlijk van je app aan! Kies een kleur die je merk het beste vertegenwoordigt",
      "sunset-ember": "Sunset Ember",
      "classic-noir": "Classic Noir",
      "system-background-colour": "Systeemachtergrondkleur",
      "customise-your-button": "Pas je knop aan",
      "customise-your-button-text-colour-and-style-to-match-your-brand": "Pas de tekst, kleur en stijl van je knop aan je merk aan.",
      "what-should-the-button-say": "Wat moet er op de knop staan?",
      "label-button-is-required": "Knoplabel is verplicht!",
      "text-colour": "Tekstkleur",
      "text-colour-is-required": "Tekstkleur is verplicht!",
      "please-input-valid-hex-color-code": "Voer een geldige hexadecimale kleurcode in",
      "background-color": "Achtergrondkleur",
      "background-colour-is-required": "Achtergrondkleur is verplicht!",
      "font-size-in-px": "Lettergrootte in px",
      "font-size-in-px-is-required": "Lettergrootte in px is verplicht!",
      "border-radius": "Randradius",
      "border-radius-is-required": "Randradius is verplicht!",
      "successfully-updated-button-style": "Knopstijl succesvol bijgewerkt",
      "font-family": "Lettertypefamilie",
      "customise-your-font": "Pas je lettertype aan",
      "match-your-store-look-and-feel-by-updating-the-font-across-your-size-charts": "Pas de uitstraling van je winkel aan door het lettertype in al je maattabellen bij te werken.",
      "select-a-font-from-the-list-bellow": "Selecteer een lettertype uit de onderstaande lijst.",
      "search-font": "Lettertype zoeken...",
      "fetching-fonts": "Lettertypen ophalen...",
      "showing-x-fonts": "{{ x }} lettertypen worden weergegeven",
      "sort-by-x": "Sorteren op {{ x }}",
      "most-popular": "Meest populair",
      "here-how-it-will-look-on-your-shop": "Zo ziet het eruit in je winkel",
      "it-ll-updated-across-all-your-chart-displays": "Het wordt bijgewerkt in alle weergaven van je tabellen.",
      "update-font-across-all-size-charts": "Lettertype bijwerken in alle maattabellen",
      "choose-a-font-to-match-your-store-style": "Kies een lettertype dat bij de stijl van je winkel past",
      "apply-font": "Lettertype toepassen",
      "font-applied-successfully": "Lettertype succesvol toegepast!",
      "manage-and-delete-your-uploaded-images-removing-a-file-is-permanent-and-cannot-be-undone": "Beheer en verwijder je geüploade afbeeldingen. Het verwijderen van een bestand is permanent en kan niet ongedaan worden gemaakt.",
      "do-you-want-to-delete-image": "Wil je de afbeelding verwijderen?",
      "image-deleted-successfully": "Afbeelding succesvol verwijderd",
      "chart-list": "Tabellenlijst",
      "delete-x-dimensions": "{{ x }} afmetingen verwijderen",
      "view-affecting-data": "Betrokken gegevens bekijken",
      "no-data-will-be-affected": "Er worden geen gegevens beïnvloed.",
      "do-you-want-to-delete-selected-dimensions": "Wil je de geselecteerde afmetingen verwijderen?",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-annotation-and-data-removed": "Bij alle annotatiesets en tabellen die deze afmetingen momenteel gebruiken, worden de annotatie en gegevens verwijderd",
      "any-annotation-sets-and-charts-currently-using-these-dimensions-will-have-its-name-changed": "Bij alle annotatiesets en tabellen die deze afmetingen momenteel gebruiken, wordt de naam gewijzigd",
      "delete-dimension": "Afmeting verwijderen",
      "successfully-deleted-dimension": "Afmeting(en) succesvol verwijderd!",
      "successfully-update-dimension": "Afmeting succesvol bijgewerkt!",
      "configure-how-back-in-stock-notifications-work-for-your-customers": "Configureer hoe meldingen bij herbevoorrading werken voor je klanten",
      "activate-back-in-stock-notifications": "Meldingen bij herbevoorrading activeren",
      "allow-shoppers-to-subscribe-for-alerts-when-a-size-or-product-is-sold-out-notifications-will-be-sent-automatically-once-stock-is-available": "Sta kopers toe zich aan te melden voor waarschuwingen wanneer een maat of product is uitverkocht. Meldingen worden automatisch verzonden zodra de voorraad weer beschikbaar is.",
      "notification-channels": "Meldingskanalen",
      "third-party-service": "Externe dienst",
      "sms": "SMS",
      "coming-soon": "Binnenkort beschikbaar",
      "signup-experience-design": "Ontwerp van de aanmeldervaring",
      "form-display": "Formulierweergave",
      "modal-popup": "Modale pop-up",
      "email-template-customisation": "Aanpassing van e-mailsjabloon",
      "subject-line": "Onderwerpregel",
      "subject-line-is-required": "Onderwerpregel is verplicht",
      "your-size-is-back-in-stock": "Je maat is weer op voorraad 🎉",
      "email-body": "E-mailtekst",
      "inventory-threshold-setting": "Instelling voorraaddrempel",
      "notify-shoppers-when-inventory-reaches-at-least": "Kopers informeren wanneer de voorraad ten minste bereikt",
      "threshold-is-required": "Drempel is verplicht",
      "threshold-must-be-greater-than-0": "Drempel moet groter zijn dan 0",
      "units": "eenheden",
      "set-the-minimum-inventory-level-required-to-trigger-notifications": "Stel het minimale voorraadniveau in dat vereist is om meldingen te activeren",
      "choose-a-service": "Kies een dienst",
      "signing-out": "Bezig met afmelden",
      "signout-of": "Afmelden bij",
      "authenticate": "Verifiëren",
      "save-settings": "Instellingen opslaan",
      "hi-your-is-now-back-in-stock-get-it-before-it-gone": "Hoi {{first_name}}, je {{product_name}} ({{size_variant}}) is weer op voorraad. Bestel snel voordat hij weer op is!",
      "successfully-updated-notification-back-in-stock": "Melding bij herbevoorrading succesvol bijgewerkt",
      "preferred-language": "Voorkeurstaal",
      "successfully-updated-your-profile": "Je profiel is succesvol bijgewerkt",
      "successfully-updated-mailing-subscription-status": "Nieuwsbriefstatus succesvol bijgewerkt!",
      "upgrade-plan": "Abonnement upgraden",
      "overview": "Overzicht",
      "billing-cycle": "Factureringscyclus",
      "billing-cycle-resets-at-midnight-on-x-and-the-next-charge-is-on-y": "De factureringscyclus wordt om middernacht op {{ x }} gereset en de volgende afschrijving is op {{ y }}",
      "billing-information": "Factureringsgegevens",
      "update-billing": "Facturering bijwerken",
      "monthly-total": "Maandelijks totaal",
      "free-trial-x-days-left": "Gratis proefperiode - nog {{ x }} dagen",
      "cancel-plan": "Abonnement opzeggen",
      "change-plan": "Abonnement wijzigen",
      "plan-and-usage": "Abonnement en gebruik",
      "tier-offers-in-use": "Gebruikte niveau-aanbiedingen",
      "failed-to-cancel-plan": "Opzeggen van abonnement mislukt",
      "total-usage": "Totaal gebruik",
      "current-usage-summary": "Overzicht van huidig gebruik",
      "published-charts": "Gepubliceerde tabellen",
      "limit-reached": "limiet bereikt",
      "plan-details": "Abonnementsdetails",
      "current-plan": "Huidig abonnement",
      "select-a-reason": "Selecteer een reden",
      "please-provide-your-reason": "Geef je reden op",
      "chart-preferences": "Tabelvoorkeuren",
      "skip-picking-dimensions-when-creating-a-new-chart-from-template": "Selectie van afmetingen overslaan bij het maken van een nieuwe tabel vanuit een sjabloon",
      "border-color": "Randkleur",
      "border-color-is-required": "Randkleur is verplicht!",
      "list-of-charts-using-this-image": "Lijst met tabellen die deze afbeelding gebruiken",
      "successfully-update-your-profile": "Je profiel is succesvol bijgewerkt"
    },
    "analytic": {
      "failed-to-load-statistics": "Statistieken konden niet worden geladen",
      "total-chart-views": "Tabelweergaven",
      "total-add-to-cart": "Toevoegingen aan winkelwagen",
      "traffic-by-location": "Verkeer per locatie",
      "desktop": "Desktop",
      "mobile": "Mobiel",
      "size-recommendations": {
        "failed-to-load": "Analyse van maataanbevelingen kon niet worden geladen",
        "total-suggestions-title": "Gedane suggesties",
        "conversion-title": "Conversie",
        "customers-proceeded": "Klanten die met de suggestie zijn doorgegaan",
        "of-x-suggestions": "van {{count}} suggesties",
        "most-suggested-title": "Meest voorgesteld product en variant",
        "suggestions-count": "{{count}} suggesties",
        "most-common-profile-title": "Meest voorkomend profiel",
        "average-profile-title": "Gemiddeld profiel",
        "gender": "Geslacht",
        "age-group": "Leeftijdsgroep",
        "height": "Lengte",
        "weight": "Gewicht",
        "size-recommended": "Aanbevolen maat",
        "graph-suggestions": "Suggesties",
        "graph-proceed": "Doorgaan",
        "source-all": "Alle",
        "source-chart": "Maattabel",
        "source-table-chart": "Roostertabel"
      },
      "chart-views": {
        "failed-to-load": "Tabelweergaven konden niet worden geladen",
        "device-types": "Apparaattypen",
        "most-viewed-chart": "Meest bekeken tabel",
        "most-viewed-product": "Meest bekeken product",
        "views-count": "{{ count }} weergaven",
        "view-at": "Bekeken op",
        "location": "Locatie",
        "graph-label": "Weergaven"
      },
      "add-to-cart": {
        "failed-to-load": "Analyse van toevoegingen aan winkelwagen kon niet worden geladen",
        "estimated-revenue": "Geschatte beïnvloede waarde",
        "conversion-title": "Conversie van tabelweergave → toevoegen aan winkelwagen",
        "most": "Meeste toevoegingen aan winkelwagen",
        "adds-count": "{{count}} toevoegingen aan winkelwagen",
        "added-at": "Toegevoegd op",
        "graph-label": "Toevoegingen aan winkelwagen",
        "views-dataset-label": "Weergaven",
        "add-to-cart-dataset-label": "Toevoegen aan winkelwagen"
      },
      "stock-notifications": {
        "failed-to-load": "Analyse van voorraadmeldingen kon niet worden geladen",
        "failed-to-load-table": "Tabel met voorraadmeldingen kon niet worden geladen",
        "total-subscriptions": "Aanmeldingen",
        "total-notifications-sent": "Verzonden meldingen",
        "delivery-rate": "Afleverpercentage",
        "opened-of-notified": "{{ opened }} geopend / {{ notified }} geïnformeerd",
        "most-subscribed": "Meest aangemeld",
        "subscriptions-count": "{{ count }} aanmeldingen",
        "latest-subscribed": "Laatste aanmelding",
        "subscribed-at": "Aangemeld op: {{ date }}",
        "longest-waiting": "Langste wachttijd op herbevoorrading",
        "waiting-days": "Wacht al: {{ days }} dagen",
        "waiting-since": "(sinds {{ date }})",
        "subscriptions": "Aanmeldingen",
        "notifications-sent": "Verzonden meldingen",
        "opened": "Geopend",
        "at": "Op",
        "graph-label": "Aanmeldingen"
      },
      "paid-gate": {
        "unlock-message": "Ontgrendel geavanceerde analyse om volledige gegevens te bekijken en betere beslissingen te nemen.",
        "upgrade": "Upgraden",
        "failed-to-fetch-plans": "Abonnementen konden niet worden opgehaald"
      },
      "buy-now": {
        "failed-to-load": "Analyse van nu kopen kon niet worden geladen",
        "total": "Nu gekocht",
        "estimated-revenue": "Geschatte beïnvloede waarde",
        "conversion-title": "Conversie van tabelweergave → nu kopen",
        "most": "Meest gekochte product via Nu kopen",
        "buys-count": "{{count}} keer nu gekocht",
        "graph-label": "Nu gekocht",
        "views-dataset-label": "Weergaven",
        "buy-now-dataset-label": "Nu kopen",
        "clicked-at": "Geklikt op"
      },
      "overview": {
        "funnel-title": "Waar de maattabelweergaven toe leidden",
        "no-views-title": "Geen tabelweergaven in deze periode",
        "no-views-hint": "Maattabellen verschijnen op productpagina’s zodra ze zijn gepubliceerd en aan producten toegewezen.",
        "chart-views-caption": "Shoppers die een maattabel openden",
        "baseline-caption": "Alles hieronder wordt afgezet tegen deze weergaven",
        "of-views": "van {{ count }} weergaven",
        "not-in-funnel": "Geen onderdeel van de maattabel-funnel"
      },
      "preview": {
        "title": "Nog geen gegevens — dit is een voorbeeld",
        "message": "De cijfers hieronder zijn voorbeeldgegevens en laten zien hoe deze pagina eruitziet zodra shoppers je maattabellen gebruiken."
      }
    },
    "plans": {
      "popular-plan": "Populair abonnement",
      "try-now": "Nu proberen",
      "activated": "Geactiveerd",
      "contact-sales": "Contact met verkoop opnemen",
      "try-free-for-1-month": "1 maand gratis proberen",
      "activate": "Activeren",
      "what-included": "Wat is inbegrepen?",
      "choose-the-plan-that-fits-your-business-needs": "Kies het abonnement dat past bij de behoeften van je bedrijf",
      "whether-youre-just-starting-out-or-looking-for-a-robust-sizing-solution-weve-got-a-plan-thats-right-for-you": "Of je nu net begint of op zoek bent naar een robuuste maatoplossing, wij hebben een abonnement dat bij je past.",
      "monthly": "Maandelijks",
      "annually": "Jaarlijks",
      "compare-plan-features": "Abonnementsfuncties vergelijken",
      "compare-all-plan-features": "Alle abonnementsfuncties vergelijken",
      "feature-usages": "Gebruik",
      "feature-analytics": "Analyses",
      "feature-support": "Ondersteuning",
      "feature-integration": "Integratie",
      "feature-branding": "Branding",
      "feature-api-access": "API-toegang",
      "feature-stock-notifications": "Voorraadmeldingen",
      "feature-published-conversion-charts": "Gepubliceerde conversietabellen",
      "feature-advanced-variant-mapping": "Geavanceerde variantkoppeling",
      "failed-to-fetch-plans": "Abonnementen konden niet worden opgehaald",
      "failed-to-activate-plan": "Activeren van abonnement mislukt",
      "contact": {
        "title": "Contact met verkoop opnemen",
        "subtitle": "Vertel ons over je winkel en wat je nodig hebt. Ons team neemt per e-mail contact met je op.",
        "message-placeholder": "Hoe kunnen we je bedrijf helpen?",
        "send": "Bericht verzenden",
        "success": "Bedankt! Je bericht is verzonden. Ons team neemt snel contact met je op.",
        "first-name-required": "Voornaam is verplicht",
        "last-name-required": "Achternaam is verplicht",
        "email-required": "E-mail is verplicht",
        "email-invalid": "E-mail is ongeldig",
        "message-required": "Bericht is verplicht"
      },
      "invite": {
        "title": "Rond je abonnement af",
        "your-plan": "Je abonnement",
        "order-summary": "Besteloverzicht",
        "billed-every-30-days": "Elke 30 dagen gefactureerd",
        "billed-yearly": "Jaarlijks gefactureerd",
        "free-trial": "{{days}} dagen gratis proberen",
        "due-today": "Vandaag te betalen",
        "then-every-30-days": "Daarna {{price}} USD per 30 dagen",
        "then-yearly": "Daarna {{price}} USD per jaar",
        "continue": "Doorgaan naar goedkeuring",
        "shopify-note": "Facturering via Shopify. Je keurt de kosten goed op het volgende scherm.",
        "switching-note": "Dit vervangt je huidige abonnement zodra je goedkeurt. Shopify verrekent het tegoed voor de resterende tijd.",
        "already-on-plan": "Je hebt dit abonnement al",
        "unavailable-title": "Deze uitnodiging is niet meer beschikbaar",
        "unavailable-body": "De link is mogelijk verlopen. Neem contact op met de afzender of bekijk de abonnementen voor alle winkels.",
        "see-plans": "Abonnementen bekijken",
        "failed-title": "Dit abonnement kon niet worden geladen",
        "failed-body": "Controleer je verbinding en laad de pagina opnieuw."
      }
    },
    "auth": {
      "signin": {
        "please-sign-in": "Log in",
        "email-is-required": "E-mailadres is verplicht",
        "invalid-email-address": "Ongeldig e-mailadres",
        "password-is-required": "Wachtwoord is verplicht",
        "sign-in": "Inloggen",
        "reset-password": "Wachtwoord opnieuw instellen",
        "generic-error": "Er is een fout opgetreden tijdens het proces! Probeer het later opnieuw."
      }
    },
    "admin": {
      "reports": {
        "title": "Rapporten",
        "chart-views": {
          "title": "Tabelweergaven",
          "description": "Bekijk hoe vaak kopers de maattabel hebben geopend, wereldwijd in alle winkels.",
          "failed-to-load": "Rapport over tabelweergaven kon niet worden geladen",
          "total-views": "Tabelweergaven",
          "most-viewed-chart": "Meest bekeken tabel",
          "most-viewed-product": "Meest bekeken product",
          "views-count": "{{ count }} weergaven",
          "traffic-by-location": "Verkeer per locatie",
          "device-types": "Apparaattypen",
          "desktop": "Desktop",
          "mobile": "Mobiel",
          "top-stores": "Beste winkels",
          "no-top-stores": "Nog geen winkelgegevens",
          "graph-label": "Weergaven",
          "view-at": "Bekeken op",
          "location": "Locatie"
        },
        "add-to-cart": {
          "title": "Toevoegen aan winkelwagen",
          "description": "Bekijk hoe de maattabel gebeurtenissen voor toevoegen aan winkelwagen beïnvloedt, wereldwijd in alle winkels.",
          "failed-to-load": "Rapport over toevoegen aan winkelwagen kon niet worden geladen",
          "total-add-to-cart": "Toevoegingen aan winkelwagen",
          "conversion-title": "Conversie van tabelweergave → toevoegen aan winkelwagen",
          "most": "Meeste toevoegingen aan winkelwagen",
          "adds-count": "{{ count }} toevoegingen aan winkelwagen",
          "top-stores": "Beste winkels",
          "no-top-stores": "Nog geen winkelgegevens",
          "graph-label": "Toevoegingen aan winkelwagen",
          "views-dataset-label": "Weergaven",
          "add-to-cart-dataset-label": "Toevoegen aan winkelwagen",
          "added-at": "Toegevoegd op"
        },
        "buy-now": {
          "title": "Nu kopen",
          "description": "Bekijk hoe de maattabel gebeurtenissen voor nu kopen beïnvloedt, wereldwijd in alle winkels.",
          "failed-to-load": "Rapport over nu kopen kon niet worden geladen",
          "total-buy-now": "Nu gekocht",
          "conversion-title": "Conversie van tabelweergave → nu kopen",
          "most": "Meest gekochte product via Nu kopen",
          "buys-count": "{{ count }} keer nu gekocht",
          "top-stores": "Beste winkels",
          "no-top-stores": "Nog geen winkelgegevens",
          "graph-label": "Nu gekocht",
          "views-dataset-label": "Weergaven",
          "buy-now-dataset-label": "Nu kopen",
          "clicked-at": "Geklikt op"
        },
        "conversion-funnel": {
          "title": "Roostertabelconversie",
          "description": "Bekijk waar verkopers afhaken bij het omzetten van een roostertabel naar een maattabel, wereldwijd in alle winkels.",
          "failed-to-load": "Rapport over roostertabelconversie kon niet worden geladen",
          "total-runs": "Gestarte conversies",
          "runs-breakdown": "{{ converted }} geconverteerd · {{ handedOver }} overgedragen",
          "conversion-title": "Gestart → Geconverteerd",
          "handover-rate": "{{ rate }}% is doorgegaan met het overdragen van hun producten",
          "handover-gap-title": "Geconverteerd, niet overgedragen",
          "of-converted-runs": "van geconverteerde pogingen",
          "handover-gap-description": "Een overdracht kan dagen later plaatsvinden, dus sommige hiervan staan nog in behandeling in plaats van te zijn opgegeven.",
          "funnel-title": "Conversietrechter",
          "funnel-note": "De speciale overdrachtsstap wordt niet meer geactiveerd — de banner is nu de manier waarop overdrachten worden voltooid, dus lees het aantal als het totale aantal overdrachten in plaats van een stapconversie.",
          "no-funnel": "Geen conversiepogingen in dit bereik",
          "drop-off": "afhaken",
          "runs-dataset-label": "Pogingen",
          "drop-offs-title": "Waar pogingen eindigen",
          "drop-offs-description": "Het laatste dat elke poging deed. Pogingen die eindigen met een voltooide overdracht — nu geregistreerd via de banner — zijn succesvol afgerond.",
          "no-drop-offs": "Geen conversiepogingen in dit bereik",
          "dwell-title": "Tijd voor het verlaten",
          "dwell-description": "Wordt alleen geregistreerd wanneer een verkoper een stap opgeeft, plus de tijd besteed aan het lezen van de beoordeling voordat wordt bevestigd.",
          "no-dwell": "Geen tijdgegevens in dit bereik",
          "step": "Stap",
          "samples": "Steekproeven",
          "median": "Mediaan",
          "p90": "P90",
          "top-stores": "Beste winkels",
          "no-top-stores": "Nog geen winkelgegevens",
          "graph-label": "Gestarte conversies",
          "started-at": "Gestart op",
          "duration": "Duur",
          "last-step": "Laatste stap",
          "outcome": "Resultaat",
          "steps": {
            "entry": "Dialoogvenster geopend",
            "category": "Categorie",
            "mapping": "Koppeling",
            "summary": "Beoordeling",
            "convert": "Converteren",
            "handover": "Overdracht",
            "banner": "Banner"
          },
          "actions": {
            "viewed": "bekeken",
            "completed": "voltooid",
            "skipped": "overgeslagen",
            "back": "teruggegaan",
            "abandoned": "opgegeven",
            "failed": "mislukt",
            "customize_clicked": "aanpassen geklikt",
            "dismissed": "genegeerd"
          },
          "outcomes": {
            "handed-over": "Overgedragen",
            "converted": "Alleen geconverteerd",
            "failed": "Mislukt",
            "abandoned": "Opgegeven",
            "in-progress": "Bezig"
          }
        }
      },
      "delete-category": "Categorie verwijderen",
      "do-you-want-to-delete-selected-categories": "Wil je de geselecteerde categorieën verwijderen?",
      "global-categories-are-shared-by-every-store": "Globale categorieën worden door alle winkels gedeeld — het verwijderen van één beïnvloedt ze allemaal. Dit kan niet ongedaan worden gemaakt.",
      "successfully-deleted-category": "Categorie succesvol verwijderd",
      "average-cost-per-recommendation": "Gemiddelde kosten per aanbeveling",
      "failed-to-load-recommendations-average-cost": "Gemiddelde kosten van aanbevelingen konden niet worden geladen",
      "most-expensive-extract": "Duurste extractie",
      "most-expensive-recommendation": "Duurste aanbeveling",
      "total-recommendation-cost": "Totale kosten van aanbevelingen",
      "total-size-recommendation": "Maataanbevelingen",
      "total-sheet-extract": "Blad-extracties",
      "new-category": "Nieuwe categorie",
      "category-created-unlisted-hint": "De categorie is aangemaakt als niet-vermeld. Voeg een afbeelding en metingen toe voordat je deze publiceert naar winkels.",
      "category-created-successfully": "Categorie succesvol aangemaakt!",
      "category-search-placeholder": "Afbeeldingsnaam, winkelnaam...",
      "dimension-search-placeholder": "Afmetingsnaam, winkelnaam...",
      "category-not-found": "Categorie niet gevonden",
      "sub-categories-variants": "Subcategorieën/varianten:",
      "add-sub-category-variant": "Subcategorie/variant toevoegen:",
      "from-existing": "Vanuit bestaande",
      "create-a-new": "Een nieuwe maken",
      "sub-category-removed": "Subcategorie verwijderd!",
      "remove-sub-category": "Subcategorie verwijderen",
      "remove-sub-category-confirm": "{{ x }} verwijderen uit deze categorie? Deze blijft beschikbaar als categorie op het hoogste niveau.",
      "update-category": "Categorie bijwerken",
      "published-category-hint": "Een gepubliceerde categorie is zichtbaar voor alle winkels. Niet-vermelde categorieën blijven verborgen.",
      "category-updated-successfully": "Categorie succesvol bijgewerkt!",
      "uninstalled": "Verwijderd",
      "inactive": "Inactief",
      "install-at": "Geïnstalleerd op",
      "total-chart-views": "Tabelweergaven",
      "chart-view-at": "Tabelweergave op",
      "store-id": "Winkel-ID",
      "successfully-deleted-clients": "Klanten succesvol verwijderd!",
      "session-replay": "Sessie-herhaling",
      "watch-on-amplitude": "Bekijken op Amplitude",
      "shopify-app": "Shopify-app",
      "shops-online-store": "Online winkel van de winkel",
      "no-more-events-to-load": "Geen gebeurtenissen meer om te laden!",
      "failed-to-fetch-events": "Gebeurtenissen konden niet worden opgehaald!",
      "info": "Info",
      "store-info": "Winkelinformatie",
      "days-ago": "{{ x }} dagen geleden",
      "contact-email": "Contact-e-mailadres",
      "store-url": "Winkel-URL",
      "activities": "Activiteiten",
      "insights": "Inzichten",
      "subscriptions": "Aanmeldingen",
      "failed-to-fetch-client-info": "Klantinformatie kon niet worden opgehaald!",
      "failed-to-load-add-to-cart-analytics": "Analyse van toevoegingen aan winkelwagen kon niet worden geladen",
      "failed-to-load-buy-now-analytics": "Analyse van nu kopen kon niet worden geladen",
      "failed-to-load-chart-views": "Tabelweergaven konden niet worden geladen",
      "failed-to-load-size-recommendations-analytics": "Analyse van maataanbevelingen kon niet worden geladen",
      "failed-to-load-stock-notifications-analytics": "Analyse van voorraadmeldingen kon niet worden geladen",
      "failed-to-load-stock-notifications-table": "Tabel met voorraadmeldingen kon niet worden geladen",
      "chart-views": "Tabelweergaven",
      "add-to-cart": "Toevoegen aan winkelwagen",
      "buy-now": "Nu kopen",
      "size-recommendations": "Maataanbevelingen",
      "stock-notifications": "Voorraadmeldingen",
      "change-details": "Gegevens wijzigen",
      "plan-subscription-details": "Details van abonnementinschrijving",
      "ai-size-recommendation-limit": "Limiet voor AI-maataanbevelingen",
      "ai-size-recommendation-limit-required": "Limiet voor AI-maataanbevelingen is verplicht!",
      "minimum-limit-is-0": "Minimumlimiet is 0!",
      "unlimited": "Onbeperkt",
      "chart-limit-drafts-hint": "Alleen gepubliceerde tabellen tellen mee. Concepten zijn onbeperkt.",
      "chart-limit-required": "Tabellimiet is verplicht!",
      "chart-limit-whole-number": "De limiet moet een geheel getal zijn!",
      "stock-notification-limit": "Limiet voor voorraadmeldingen",
      "stock-notification-limit-required": "Limiet voor voorraadmeldingen is verplicht!",
      "published-size-chart-limit": "Limiet voor gepubliceerde maattabellen",
      "published-table-chart-limit": "Limiet voor gepubliceerde roostertabellen",
      "analytic": "Analyse",
      "full-suite": "Volledig pakket",
      "select-a-subscription-plan": "Selecteer een abonnement",
      "failed-to-fetch-plans": "Abonnementen konden niet worden opgehaald!",
      "new-plan": "Nieuw abonnement",
      "failed-to-assign-plan-subscription-to-client": "Abonnementinschrijving kon niet aan klant worden toegewezen!",
      "ai-size-recommendation": "AI-maataanbeveling",
      "stock-notification": "Voorraadmelding",
      "published-size-charts": "Gepubliceerde maattabellen",
      "published-table-charts": "Gepubliceerde roostertabellen",
      "analytic-access": "Toegang tot analyse",
      "activated-at": "Geactiveerd op",
      "usages": "Gebruiken",
      "failed-to-fetch-client-plan-subscription": "Abonnementinschrijving van klant kon niet worden opgehaald!",
      "advanced-variant-mapping": "Geavanceerde variantkoppeling",
      "advanced-variant-mapping-description": "Tabellen gebruiken hun eigen maten op elk toegewezen product, en In winkelwagen kiest de bijpassende productvariant. Uitgeschakeld moeten de maten van een tabel exact overeenkomen met de variantnamen van elk product.",
      "advanced-variant-mapping-counts": "{{ total }} tabellen · {{ x }} met geavanceerde variantkoppeling",
      "advanced-variant-mapping-drift": "{{ x }} tabellen komen niet overeen met deze instelling.",
      "advanced-variant-mapping-repair": "Herstellen",
      "turn-on-advanced-variant-mapping": "Geavanceerde variantkoppeling inschakelen?",
      "turn-off-advanced-variant-mapping": "Geavanceerde variantkoppeling uitschakelen?",
      "advanced-variant-mapping-on-body": "Alle {{ x }} tabellen van deze klant schakelen direct over, en nieuwe tabellen gebruiken het ook. Maten worden niet gewijzigd en je kunt het weer uitschakelen.",
      "advanced-variant-mapping-off-body": "Alle {{ x }} tabellen van deze klant gaan terug naar exacte koppeling op variantnaam. Tabellen waarvan de maten zijn hernoemd terwijl het aan stond (bijv. \"Blue / S\" naar \"S\") tonen lege maten bij producten waarvan de variantnamen niet meer overeenkomen.",
      "turn-on": "Inschakelen",
      "turn-off": "Uitschakelen",
      "failed-to-fetch-advanced-variant-mapping": "Geavanceerde variantkoppeling ophalen mislukt!",
      "failed-to-update-advanced-variant-mapping": "Geavanceerde variantkoppeling bijwerken mislukt!",
      "plan-used-as-free-trial": "Abonnement gebruikt als gratis proefperiode voor nieuw geregistreerde klanten",
      "x-usages": "{{ x }} keer gebruikt",
      "successfully-updated-configuration-value": "Configuratiewaarde succesvol bijgewerkt",
      "only-authorized-personnel-hint": "Alleen bevoegd personeel mag de globale configuratie van de applicatie openen en wijzigen!",
      "password-is-required": "Wachtwoord is verplicht",
      "authorize": "Autoriseren",
      "1-month": "1 maand",
      "3-months": "3 maanden",
      "6-months": "6 maanden",
      "1-year": "1 jaar",
      "failed-to-load-costs": "Kosten konden niet worden geladen",
      "failed-to-load-total-recommendations": "Totaal aantal aanbevelingen kon niet worden geladen",
      "archived": "Gearchiveerd",
      "billing-interval": "Factureringsinterval",
      "plan-information": "Abonnementsinformatie",
      "name-is-required": "Naam is verplicht!",
      "features": "Functies",
      "stock-notification-recommendation-limit": "Limiet voor aanbevelingen voor voorraadmeldingen",
      "popular": "Populair",
      "allow-trial": "Proefperiode toestaan",
      "interval": "Interval",
      "interval-is-required": "Interval is verplicht!",
      "price-is-required": "Prijs is verplicht!",
      "minimum-price-is-0": "Minimumprijs is 0!",
      "discounted-from": "Korting van",
      "description": "Beschrijving",
      "description-is-required": "Beschrijving is verplicht!",
      "selling-points": "Verkoopargumenten",
      "selling-point-x": "Verkoopargument {{ x }}",
      "selling-point-is-required": "Verkoopargument is verplicht!",
      "analytic-is-required": "Analyse is verplicht!",
      "support": "Ondersteuning",
      "support-is-required": "Ondersteuning is verplicht!",
      "status-is-required": "Status is verplicht!",
      "manage-preset-dimensions": "Beheer vooraf ingestelde afmetingen, hun detectiesynoniemen en vertalingen.",
      "detection-synonyms": "Detectiesynoniemen",
      "add-synonym-placeholder": "Typ een synoniem en druk op Enter",
      "translations": "Vertalingen",
      "missing-translation": "Ontbrekende vertaling",
      "new-dimension": "Nieuwe afmeting",
      "edit-dimension": "Afmeting bewerken",
      "delete-preset-dimension": "Vooraf ingestelde afmeting verwijderen",
      "do-you-want-to-delete-this-preset-dimension": "Wil je \"{{ name }}\" verwijderen?",
      "preset-dimensions-are-shared-by-every-store": "Vooraf ingestelde afmetingen worden door alle winkels gedeeld — het verwijderen van één verwijdert deze uit alle categorieën die deze gebruiken. Dit kan niet ongedaan worden gemaakt.",
      "successfully-created-dimension": "Afmeting succesvol aangemaakt!",
      "successfully-updated-dimension": "Afmeting succesvol bijgewerkt!",
      "successfully-deleted-dimension": "Afmeting succesvol verwijderd!",
      "ai-provider-for-file-imports": "AI-provider voor bestandsimports",
      "no-api-key-configured-in-this-environment": "Geen API-sleutel geconfigureerd in deze omgeving",
      "ai-provider-saved-applies-to-new-imports": "AI-provider opgeslagen. Dit geldt voor nieuwe imports; imports die al lopen houden hun provider.",
      "ai-provider-for-size-recommendations": "AI-provider voor maataanbevelingen",
      "ai-provider-saved-applies-to-next-recommendation": "AI-provider opgeslagen. Dit geldt vanaf de volgende maataanbeveling.",
      "size-recommendation-provider-hint": "Gebruikt voor AI-maataanbevelingen aan shoppers. Los van bestandsimports.",
      "ai-measurement-import": "Maten importeren met AI",
      "name-admin-only": "Naam (alleen voor beheerders)",
      "name-admin-only-hint": "De app herkent de Free- en Enterprise-abonnementen aan deze naam, dus hernoem die niet.",
      "display-name": "Weergavenaam",
      "display-name-hint": "Wordt aan verkopers getoond op de abonnementenpagina, de factureringspagina's en de Shopify-afschrijving. Laat leeg om de naam te gebruiken.",
      "display-name-too-long": "De weergavenaam mag maximaal 40 tekens lang zijn!",
      "availability": "Beschikbaarheid",
      "available-from-utc": "Beschikbaar vanaf (UTC)",
      "available-from-hint": "Laat leeg om het aan te bieden zodra het actief is.",
      "expires-at-utc": "Verloopt op (UTC)",
      "expires-at-required": "Stel in wanneer het verloopt!",
      "window-order": "Het moet beschikbaar worden voordat het verloopt!",
      "your-time": "Jouw tijd: {{time}}",
      "availability-always": "Altijd aangeboden",
      "availability-scheduled": "Gepland: nog niet aangeboden",
      "availability-live": "Actief: wordt nu aangeboden",
      "availability-ended": "Beëindigd: wordt niet meer aangeboden",
      "promo-plan": "Actieabonnement",
      "replaces-plan": "Vervangt",
      "replaces-plan-none": "Niets (een gewoon abonnement)",
      "replaces-plan-hint": "Zolang dit abonnement wordt aangeboden, zien verkopers het in plaats van het abonnement dat het vervangt.",
      "campaign": "Campagne",
      "campaign-required": "Kies de campagne waar dit actieabonnement bij hoort!",
      "merchants-see": "Verkopers zien",
      "replaces-x": "vervangt {{x}}",
      "archiving-hint": "Archiveren verbergt een abonnement alleen voor nieuwe abonnees. Huidige abonnees houden het.",
      "duplicate-as-promo-plan": "Dupliceren als actieabonnement",
      "help-articles": {
        "topic": "Onderwerp",
        "all-topics": "Alle onderwerpen",
        "topics": {
          "getting-started": "Aan de slag",
          "size-charts": "Maattabellen",
          "table-charts": "Roostertabellen",
          "assigning-products": "Toewijzen aan producten",
          "storefront-display": "Weergave in de winkel",
          "chart-import": "Tabellen importeren",
          "size-recommendations": "Maatadviezen",
          "plans-billing": "Abonnementen en facturering",
          "troubleshooting": "Problemen oplossen"
        },
        "new-article": "Nieuw helpartikel",
        "slug": "Slug",
        "slug-hint": "Het adres van het artikel in het helpcentrum: /help/jouw-slug. Als je het wijzigt, werken links naar het oude adres niet meer.",
        "slug-invalid": "Gebruik kleine letters, cijfers en enkele koppeltekens.",
        "slug-taken": "Een ander artikel gebruikt deze slug al.",
        "title-is-required": "Titel is verplicht",
        "summary": "Samenvatting",
        "summary-hint": "Eén regel. De supportassistent kiest artikelen op basis van hun samenvatting.",
        "summary-is-required": "Samenvatting is verplicht",
        "order": "Volgorde",
        "body-hint": "Markdown. Link naar een ander artikel met [tekst](/help/zijn-slug).",
        "insert-image": "Afbeelding invoegen",
        "image-upload-failed": "De afbeelding kon niet worden geüpload.",
        "view-on-help-centre": "Bekijken in het helpcentrum",
        "broken-links": "Gepubliceerd, maar deze links verwijzen naar artikelen die niet bestaan of niet gepubliceerd zijn:",
        "article-saved": "Artikel opgeslagen",
        "article-published": "Artikel gepubliceerd",
        "article-unpublished": "Publicatie van artikel ingetrokken",
        "article-deleted": "Artikel verwijderd",
        "delete-article": "Artikel verwijderen",
        "delete-article-prompt": "\"{{title}}\" verwijderen? Het verdwijnt meteen uit het helpcentrum en uit de supportassistent.",
        "load-failed": "Het artikel kon niet worden geladen.",
        "export": "Exporteren",
        "import": "Importeren",
        "export-failed": "De artikelen konden niet worden geëxporteerd.",
        "import-title": "Helpartikelen importeren",
        "import-checking": "Bestand controleren…",
        "import-preview": "{{file}} maakt {{created}} artikelen aan en werkt er {{updated}} bij, met {{images}} afbeeldingen. Artikelen die niet in het bestand staan, blijven ongewijzigd.",
        "import-invalid": "Dit bestand kan niet worden geïmporteerd:",
        "imported": "Geïmporteerd: {{created}} aangemaakt, {{updated}} bijgewerkt."
      },
      "invite-only": "Alleen op uitnodiging",
      "invite-only-hint": "Verborgen op de abonnementenpagina. Iedereen met de link kan zich abonneren. Dit kan na het aanmaken niet worden gewijzigd.",
      "invite-only-price-required": "Een abonnement op uitnodiging moet een prijs boven 0 hebben",
      "copy-invite-link": "Uitnodigingslink kopiëren",
      "invite-link-copied": "Uitnodigingslink gekopieerd",
      "invite-link-copy-failed": "Kan de uitnodigingslink niet kopiëren"
    }
  },
  "search": {
    "no-result-found": "Geen resultaat gevonden!",
    "type": {
      "product": "Product",
      "variant": "Variant",
      "client": "Klant"
    },
    "show-less": "Minder weergeven",
    "show-full": "Alles weergeven",
    "search-x-by-full-name": "{{ x }} zoeken op volledige naam",
    "load-more...": "Meer laden..."
  },
  "privacy-policy": "Privacybeleid",
  "contact-us": "Neem contact met ons op",
  "notification": {
    "notification": "Melding",
    "mark-all-as-read": "Alles als gelezen markeren",
    "compose": "Melding opstellen",
    "title-required": "Titel is verplicht!",
    "message-required": "Bericht is verplicht!",
    "sent-to-all-clients": "Er is een melding verzonden naar alle klanten"
  },
  "table": {
    "sort": "Sorteren",
    "sort-by": "Sorteren op",
    "oldest-first": "Oudste eerst",
    "newest-first": "Nieuwste eerst",
    "a-z": "A tot Z",
    "z-a": "Z tot A",
    "lowest-first": "Laagste eerst",
    "highest-first": "Hoogste eerst",
    "no-data-found": "Geen gegevens gevonden"
  },
  "grading": {
    "grading-configuration": "Gradatieconfiguratie",
    "base-size": "Basismaat",
    "enter-your-grading-allowances": "Voer je gradatietoleranties in",
    "base": "Basis"
  },
  "chart": {
    "image-nav-previous": "Vorige afbeelding",
    "image-nav-next": "Volgende afbeelding",
    "image-nav-position": "{{current}} / {{total}}",
    "image-add-slot-placeholder": "Nog een afbeelding toevoegen",
    "image-add-slot-formats": "Accepteert .png, .jpeg, .jpg",
    "image-cap-reached": "Je hebt het maximale aantal afbeeldingen voor deze categorie bereikt.",
    "image-upload-failed": "De afbeelding kon niet worden geüpload. Probeer het opnieuw.",
    "image-svg-not-accepted": "SVG-bestanden worden hier niet geaccepteerd.",
    "image-delete": "Afbeelding verwijderen",
    "image-move-left": "Afbeelding naar links verplaatsen",
    "image-move-right": "Afbeelding naar rechts verplaatsen",
    "image-delete-confirm-title": "Deze afbeelding verwijderen?",
    "image-delete-confirm-body": "Deze afbeelding wordt permanent verwijderd en kan niet worden hersteld.",
    "image-delete-confirm-cancel": "Annuleren",
    "image-delete-confirm-action": "Afbeelding verwijderen",
    "image-delete-last-tooltip": "Een categorie moet minstens één afbeelding behouden.",
    "image-customize-first-tooltip": "Pas deze categorie eerst aan om de afbeeldingen te beheren.",
    "image-delete-failed": "De afbeelding kon niet worden verwijderd. Probeer het opnieuw.",
    "image-reorder-failed": "De afbeeldingen konden niet opnieuw worden geordend. Probeer het opnieuw.",
    "do-you-want-to-delete-this-chart": "Wil je deze tabel verwijderen?",
    "unnamed-chart": "Naamloze tabel",
    "get-size-chart-permalink": "Permanente link naar maattabel ophalen",
    "chart-external-link-is-copied-to-clipboard": "Externe link van de tabel is gekopieerd naar het klembord",
    "failed-to-duplicate-chart": "Dupliceren van tabel mislukt",
    "failed-to-create-chart": "Maken van tabel mislukt",
    "add-new-layout-blocks": "Nieuwe lay-outblokken toevoegen",
    "click-on-these-layout-types-and-add-to-the-size-chart": "Klik op deze lay-outtypen en voeg ze toe aan de maattabel",
    "rename-chart": "Tabel hernoemen",
    "chart-renamed-successfully": "Tabel succesvol hernoemd",
    "failed-to-rename-chart": "Hernoemen van tabel mislukt",
    "preview": "Voorbeeld",
    "model-info": "Modelinformatie",
    "model-details": "Modeldetails",
    "help-shoppers-by-showing-the-model-height-and-size": "Help kopers door de lengte en maat van het model te tonen",
    "model-name": "Modelnaam",
    "enter-model-name": "Modelnaam invoeren",
    "model-height": "Modellengte",
    "please-enter-valid-number": "Voer een geldig getal in",
    "size-worn": "Gedragen maat",
    "show-variants-by": "Varianten weergeven op",
    "add-options-like-size-or-color": "Voeg opties toe zoals maat of kleur",
    "select-existing-chart": "Bestaande tabel selecteren",
    "search-charts": "Tabellen zoeken op naam",
    "no-charts-found": "Geen tabellen gevonden",
    "search-dimensions": "Afmetingen zoeken",
    "no-dimensions-found": "Geen afmetingen gevonden",
    "add-a-new-size-chart": "Nieuwe maattabel toevoegen",
    "this-product-is-using-table-chart": "Dit product gebruikt een roostertabel",
    "update-your-size-chart": "Werk je maattabel bij",
    "create-your-size-chart": "Maak je maattabel",
    "use-a-template": "Een sjabloon gebruiken",
    "use-template-variants": "Sjabloon en varianten gebruiken",
    "pick-a-method-to-get-started": "Kies een methode om te beginnen",
    "select-an-existing-chart": "Een bestaande tabel selecteren",
    "image-set-annotation-panel": "Annotatiepaneel voor afbeeldingsset",
    "measure-guide": "Meetgids...",
    "drag-drop-to-mark-measurement-bubble": "Sleep om het meetpunt te markeren",
    "are-you-sure-you-want-to-delete-all-measurements": "Weet je zeker dat je alle metingen wilt verwijderen?",
    "accepts-png-jpeg-jpg-svg": "Accepteert .png, .jpeg, .jpg, .svg",
    "this-name-will-appear-in": "Deze naam verschijnt in",
    "image-set": "afbeeldingsset",
    "added-measurements": "Toegevoegde metingen",
    "no-measurements-added-yet": "Nog geen metingen toegevoegd",
    "drag-and-drop-a-chip-to-edit-its-line-on-the-canvas": "Sleep een chip om de bijbehorende lijn op het canvas te bewerken",
    "after-adding-a-measurement-drag-and-drop-it-from-the-section-above-onto-the-image": "Sleep een meting na het toevoegen ervan vanuit de sectie 'Toegevoegde metingen' hierboven naar de afbeelding",
    "across-shoulder-front-rise-belt": "Schouderbreedte, voorstuk, riem, ...",
    "create-measurement": "Meting maken",
    "examples-across-shoulder-front-rise-cuff-width": "Voorbeelden: 'Schouderbreedte', 'Voorstuk', 'Manchetbreedte'",
    "delete-anotation-set": "Annotatieset verwijderen",
    "this-will-remove-all-measurements-from-this-image": "Dit verwijdert alle metingen van deze afbeelding",
    "measurement-name": "Metingnaam",
    "size-recommender": "Maatadviseur",
    "size-recommender-history": "Recente aanbevelingen",
    "your-buyer-personal-fitting-assistant-that-instantly-suggests-the-perfect-size-every-time": "De persoonlijke pasassistent van je koper die elke keer direct de perfecte maat voorstelt",
    "stretch-factor": "Rekfactor",
    "how-stretchy-is-the-fabric-a-rough-estimate-is-enough-if-unsure-then-leave-at-10": "Hoe rekbaar is de stof? Een ruwe schatting is voldoende. Laat het op 10% staan als je het niet zeker weet",
    "easing": "Bewegingsruimte",
    "wearing-ease-is-the-amount-added-to-a-person-body-measurements-so-one-can-move-in-a-garment": "Bewegingsruimte is de hoeveelheid die wordt toegevoegd aan de lichaamsmaten van een persoon zodat men kan bewegen in een kledingstuk.",
    "set-default": "Instellen als standaard",
    "suggested": "Voorgesteld",
    "assign-chart": "Tabel toewijzen",
    "your-chart-has-not-been-assigned-to-any-product-yet": "Je tabel is nog niet toegewezen aan een product",
    "assign-your-chart-so-it-will-appear-on-product-pages": "Wijs je tabel toe zodat deze op productpagina's verschijnt",
    "assign-it-to-a-product": "Toewijzen aan een product",
    "select-the-products-or-collections-where-you-want-your-size-chart-to-appear": "Selecteer de producten of collecties waar je maattabel moet verschijnen",
    "x-matched-y": "{{ x }} kwam overeen met {{ y }}",
    "overwritting-x-products": "(overschrijft {{ x }} producten)",
    "calculating...": "Bezig met berekenen...",
    "select-product-or-collection": "Product of collectie selecteren",
    "remove-all": "Alles verwijderen",
    "are-you-sure-you-want-to-remove-all-conditions": "Weet je zeker dat je alle voorwaarden wilt verwijderen?",
    "list-of-matched-products": "Lijst met overeenkomende producten",
    "give-your-size-chart-a-name": "Geef je maattabel een naam",
    "this-name-is-only-used-internally-to-help-you-organise-your-charts-customers-wont-see-it": "Deze naam wordt alleen intern gebruikt om je te helpen je tabellen te organiseren. Klanten zien deze niet.",
    "eg-mens-t-shirt-size-chart": "bijv. Maattabel voor herenshirts",
    "add-text-block": "Tekstblok toevoegen",
    "product-image-optional": "Productafbeelding (optioneel)",
    "add-layout-block": "Lay-outblok toevoegen",
    "move-this-block-up": "Dit blok omhoog verplaatsen",
    "move-this-block-down": "Dit blok omlaag verplaatsen",
    "clear-this-image": "Deze afbeelding wissen",
    "align-this-image": "Deze afbeelding uitlijnen",
    "clear-this-video": "Deze video wissen",
    "apply-grading-to-this-table": "Gradatie toepassen op deze tabel",
    "duplicate-this-block-to-below": "Dit blok hieronder dupliceren",
    "remove-this-block": "Dit blok verwijderen",
    "upload-an-image": "Een afbeelding uploaden",
    "browse-to-upload": "Bladeren om te uploaden",
    "choose-from-our": "Kies uit onze",
    "ready-made-templates": "kant-en-klare sjablonen",
    "select-a-template": "Een sjabloon selecteren",
    "new-row": "Nieuwe rij",
    "new-column": "Nieuwe kolom",
    "add-column-left": "Kolom links toevoegen",
    "add-column-right": "Kolom rechts toevoegen",
    "move-left": "Naar links verplaatsen",
    "move-right": "Naar rechts verplaatsen",
    "freeze": "Vastzetten",
    "unfreeze": "Losmaken",
    "delete-column": "Kolom verwijderen",
    "add-row-above": "Rij erboven toevoegen",
    "add-row-below": "Rij eronder toevoegen",
    "move-up": "Omhoog verplaatsen",
    "move-down": "Omlaag verplaatsen",
    "delete-row": "Rij verwijderen",
    "insert-video": "Video invoegen",
    "select-a-video": "Een video selecteren",
    "paste-a-link-to-a-video-here": "Plak hier een link naar een video",
    "webgl-not-supported": "Je browser ondersteunt WebGL niet. Schakel WebGL-ondersteuning in als je een moderne browser gebruikt zoals Chrome, Firefox of Safari.",
    "table-chart-created": "Roostertabel aangemaakt",
    "name-this-image-set": "Geef deze afbeeldingsset een naam",
    "name-your-import": "Geef je import een naam",
    "table-chart-updated": "Roostertabel bijgewerkt",
    "chart-updated": "Tabel bijgewerkt",
    "use-how-to-measure-block": "'Hoe te meten'-blok gebruiken? (Optioneel)",
    "a-text-block-under-an-expandable-panel-will-be-added-where-you-can-fill-in-details-for-your-customers-on-how-to-measure-their-measurements": "Er wordt een tekstblok toegevoegd onder een uitklapbaar paneel waar je details voor je klanten kunt invullen over hoe ze hun metingen moeten uitvoeren",
    "newest-5-recommendations-given-to-your-customers": "De 5 nieuwste aanbevelingen gegeven aan je klanten",
    "size-recommended": "Aanbevolen maat",
    "view-all-data": "Alle gegevens bekijken",
    "please-select-a-size-worn": "Selecteer een gedragen maat",
    "recommended-for-this-garment-add-or-remove-as-needed": "Aanbevolen voor dit kledingstuk, voeg toe of verwijder indien nodig",
    "add-more": "Meer toevoegen",
    "add-custom-measurements": "Aangepaste metingen toevoegen",
    "skip-this-step-next-time": "Deze stap de volgende keer overslaan",
    "use-unit-conversion": "Eenheidsconversie gebruiken",
    "disabled-by-chart": "Uitgeschakeld door tabel",
    "disabled-globally-by-settings": "Globaal uitgeschakeld door instellingen",
    "hide-unit-conversion-toggle-on-all-charts-appear-on-your-storefront": "Eenheidsconversieschakelaar verbergen op alle tabellen die in je winkel verschijnen",
    "assign-products": "Producten toewijzen",
    "select-products-to-assign-to-the-chart": "Selecteer producten om aan de tabel toe te wijzen",
    "products-assigned-successfully": "Producten succesvol toegewezen",
    "source-table": "Brontabel",
    "root-table": "Hoofdtabel",
    "table-block": "Tabel",
    "which-axis-holds-the-dimension-data": "Welke as bevat de afmetingsgegevens? (Schouder, taille, enz.)",
    "columns": "Kolommen",
    "rows": "Rijen",
    "measurement-unit": "Meeteenheid",
    "map-each-line-to-a-dimension": "Koppel elke regel aan een afmeting",
    "ignore": "Negeren",
    "line": "Regel",
    "the-selected-table-has-no-data-to-map": "De geselecteerde tabel heeft geen gegevens om te koppelen.",
    "tell-us-how-your-table-maps-to-body-dimensions-so-we-can-suggest-a-size": "Vertel ons hoe je tabel overeenkomt met lichaamsafmetingen, zodat we een maat kunnen voorstellen.",
    "choose-which-table-the-ai-reads-to-suggest-a-size": "Kies welke tabel de AI leest om een maat voor te stellen.",
    "per-dimension-stretch-and-easing-controls": "Rek- en bewegingsruimte-instellingen per afmeting",
    "jump-to-table": "Naar tabel springen",
    "scroll-to-the-selected-table": "Naar de geselecteerde tabel scrollen",
    "this-table-is-used-as-your-size-recommendation-data-source": "Deze tabel wordt gebruikt als gegevensbron voor je maataanbeveling",
    "this-table-block-can-not-be-deleted-right-now": "Dit tabelblok kan momenteel niet worden verwijderd"
  },
  "error": {
    "there-was-an-error-while-authenticating-your-store": "Er is een fout opgetreden bij het verifiëren van je winkel!",
    "click-the-button-below-to-try-again-if-the-issue-persisted-contact-us-for-further-instruction": "Klik op de knop hieronder om het opnieuw te proberen. Als het probleem aanhoudt, neem dan contact met ons op voor verdere instructies.",
    "refresh-the-app": "App vernieuwen",
    "error-occured": "Er is een fout opgetreden!"
  },
  "banner": {
    "add-the-goodchart-size-guide-button-to-your-storefront": "Voeg de Goodchart-maatgidsknop toe aan je winkel",
    "we-ve-detected-you-are-integrating-with-shopify-enable-app-embed-or-add-an-app-block": "We hebben gedetecteerd dat je integreert met Shopify. Schakel app-insluiting in om de maatgidsknop automatisch op elke productpagina weer te geven, of voeg een app-blok toe om deze op een specifieke plek te plaatsen. Hulp nodig? Bekijk deze <a class=\"underline\" href=\"{{ guide }}\" target=\"_blank\">handleiding</a>.",
    "enable-app-embed": "App-insluiting inschakelen",
    "add-app-block": "App-blok toevoegen",
    "your-new-size-chart-is-ready-to-review": "Je nieuwe maattabel is klaar om te worden beoordeeld",
    "look-around-then-hand-the-conversion-over": "Er is nog niets veranderd voor je kopers — je roostertabel is nog steeds de actieve. Neem de tijd om de metingen en de gids te controleren, en draag de conversie dan over wanneer alles er goed uitziet.",
    "about-your-plan-usage": "Over je abonnementsgebruik",
    "measurements-applied": "Metingen toegepast",
    "selection-applied-all-variants": "De selectie is toegepast op alle maatvarianten.",
    "you-have-reached-x-of-ai-size-recommendations-limit": "Je hebt {{ x }}% van de limiet voor AI-maataanbevelingen van je huidige abonnement bereikt. Houd er rekening mee dat gebruik boven 100% tegen het standaardtarief in rekening wordt gebracht.",
    "you-have-reached-x-of-stock-notification-limit": "Je hebt {{ x }}% van de limiet voor voorraadmeldingen van je huidige abonnement bereikt.",
    "over-usage-cost": "Overschrijdingskosten",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-service": "Je hebt je limiet voor AI-maataanbevelingen overschreden. Betaal de overschrijdingskosten om de service te blijven gebruiken.",
    "you-have-exceeded-ai-size-recommendation-limit-pay-to-continue-using-this-feature": "Je hebt je limiet voor AI-maataanbevelingen overschreden. Betaal de overschrijdingskosten om deze functie te blijven gebruiken.",
    "n-of-your-table-charts-can-be-upgraded-to-smart-size-charts": "{{count}} van je roostertabellen kunnen worden geüpgraded naar slimme maattabellen"
  },
  "onboarding": {
    "skip-for-now": "Voorlopig overslaan",
    "step-x-of-y": "Stap {{ x }} van {{ y }}",
    "select-the-category-that-best-matches-your-product": "Selecteer de categorie die het beste bij je product past.",
    "apparel": "Kleding",
    "tops": "Bovenkleding",
    "pants": "Broeken",
    "dresses": "Jurken",
    "shoes": "Schoenen",
    "sneakers": "Sneakers",
    "boots": "Laarzen",
    "sandals": "Sandalen",
    "accessories": "Accessoires",
    "belts": "Riemen",
    "bags": "Tassen",
    "hats": "Hoeden",
    "other-custom": "Anders/aangepast",
    "equipment": "Uitrusting",
    "tool": "Gereedschap",
    "furniture": "Meubels",
    "upload-any-product-image-and-place-measurements-visually-works-for-apparel-shoes-and-accessories": "Upload een willekeurige productafbeelding en plaats metingen visueel. Werkt voor kleding, schoenen en accessoires.",
    "table-style-chart": "Tabel in roosterstijl",
    "create-a-grid-based-chart-with-rows-and-columns-best-for-detailed-size-specifications": "Maak een op een rooster gebaseerde tabel met rijen en kolommen. Ideaal voor gedetailleerde maatspecificaties.",
    "your-size-chart-is-ready": "Je maattabel is klaar",
    "you-can-now-decide-where-this-size-chart-should-appear-in-your-store-you-can-skip-this-step-and-assign-products-later": "Je kunt nu bepalen waar deze maattabel in je winkel moet verschijnen. Je kunt deze stap overslaan en later producten toewijzen.",
    "apply-this-chart-to-products-now": "Deze tabel nu toepassen op producten",
    "choose-which-products-should-use-this-size-chart": "Kies welke producten deze maattabel moeten gebruiken.",
    "i-ll-do-this-later": "Ik doe dit later",
    "you-can-assign-or-change-matching-anytime-from-chart-settings": "Je kunt de toewijzing of koppeling op elk moment wijzigen vanuit de tabelinstellingen.",
    "select-products-to-assign-chart-to": "Selecteer producten om de tabel aan toe te wijzen",
    "apply-this-chart-to-all-products": "Deze tabel toepassen op alle producten.",
    "select-products-to-apply-this-chart-to": "Selecteer producten om deze tabel op toe te passen.",
    "assigning...": "Bezig met toewijzen...",
    "size-chart-created-successfully": "Maattabel succesvol aangemaakt",
    "you-can-assign-products-anytime-from-chart-settings": "Je kunt op elk moment producten toewijzen vanuit de tabelinstellingen.",
    "view-chart": "Tabel bekijken",
    "go-to-dashboard": "Naar dashboard gaan",
    "turn-your-size-chart-into-a-conversion-tool": "Maak van je maattabel een conversietool",
    "help-shoppers-pick-the-right-size-and-reduce-returns": "Help kopers de juiste maat te kiezen en verminder retouren.",
    "setup-takes-about-2-minutes": "De instelling duurt ongeveer 2 minuten.",
    "choose-how-your-size-chart-looks": "Kies hoe je maattabel eruitziet",
    "other-ways-to-create-a-chart": "Andere manieren om een tabel te maken",
    "failed-to-proceed-please-try-again": "Doorgaan mislukt, probeer het opnieuw",
    "this-chart-connects-to-your-shopify-product-and-variants-so-shoppers-can-select-their-size-add-to-cart-or-buy-now-without-leaving-the-chart": "Deze tabel maakt verbinding met je Shopify-product en varianten, zodat kopers hun maat kunnen selecteren, aan de winkelwagen kunnen toevoegen of nu kunnen kopen zonder de tabel te verlaten",
    "add-the-size-guide-button-to-your-storefront": "Voeg de maatgidsknop toe aan je winkel",
    "choose-how-the-goodchart-size-guide-button-should-appear-on-your-product-pages": "Kies hoe de GoodChart-maatgidsknop op je productpagina's moet verschijnen.",
    "enable-app-embed": "App-insluiting inschakelen",
    "installed": "Geïnstalleerd",
    "automatically-display-the-size-guide-button-on-all-product-pages": "Toon de maatgidsknop automatisch op alle productpagina's.",
    "add-app-block-to-product-page": "App-blok toevoegen aan productpagina",
    "prefer-to-place-the-button-in-a-specific-spot-on-your-product-page": "Wil je de knop liever op een specifieke plek op je productpagina plaatsen?",
    "place-the-size-guide-button-in-a-specific-spot-on-your-product-page-template": "Plaats de maatgidsknop op een specifieke plek in je productpaginasjabloon.",
    "open": "Openen",
    "check-button-installation": "Knopinstallatie controleren",
    "checking": "Bezig met controleren...",
    "great-the-size-guide-button-is-installed-on-your-storefront": "Geweldig! De maatgidsknop is geïnstalleerd in je winkel.",
    "we-could-not-detect-the-size-guide-button-yet-please-make-sure-you-saved-the-changes-in-the-theme-editor": "We konden de maatgidsknop nog niet detecteren. Zorg ervoor dat je de wijzigingen in de thema-editor hebt opgeslagen.",
    "app-block-installed-on-your-product-page": "App-blok geïnstalleerd op je productpagina"
  },
  "common": {
    "updated": "Bijgewerkt",
    "name": "Naam",
    "avatar": "Avatar",
    "category-image": "Categorieafbeelding",
    "increase": "Verhogen",
    "created": "Aangemaakt",
    "email": "E-mail",
    "password": "Wachtwoord",
    "yes": "Ja",
    "no": "Nee",
    "chart": "Tabel",
    "gender": "Geslacht",
    "height": "Lengte",
    "weight": "Gewicht",
    "age-group": "Leeftijdsgroep",
    "fit-preference": "Pasvoorkeur",
    "score": "Score",
    "table-chart": "Roostertabel",
    "draft": "Concept",
    "active": "Actief",
    "products": "Producten",
    "none": "Geen",
    "cancel": "Annuleren",
    "retry": "Opnieuw proberen",
    "delete": "Verwijderen",
    "export": "Exporteren",
    "variant": "Variant",
    "variants": "Varianten",
    "account": "Account",
    "personal": "Persoonlijk",
    "appearance": "Uiterlijk",
    "organization": "Organisatie",
    "information": "Informatie",
    "first-name": "Voornaam",
    "last-name": "Achternaam",
    "save": "Opslaan",
    "pay": "Betalen",
    "undo": "Ongedaan maken",
    "redo": "Opnieuw uitvoeren",
    "newsletter-subscription": "Nieuwsbriefaanmelding",
    "button": "Knop",
    "colour": "Kleur",
    "default": "Standaard",
    "white": "Wit",
    "light-grey": "Lichtgrijs",
    "soft-beige": "Zacht beige",
    "saving...": "Bezig met opslaan...",
    "all-changes-saved": "Alle wijzigingen opgeslagen",
    "publish": "Publiceren",
    "unpublish": "Publicatie ongedaan maken",
    "images": "Afbeeldingen",
    "charts": "Tabellen",
    "confirm": "Bevestigen",
    "dimensions": "Afmetingen",
    "new": "Nieuw",
    "missing": "Ontbrekend",
    "editing-x": "{{ x }} bewerken",
    "back-in-stock": "Weer op voorraad",
    "product": "Product",
    "grading": "Gradatie",
    "more-actions": "Meer acties",
    "table": "Tabel",
    "measurement": "Meting",
    "close": "Sluiten",
    "apply": "Toepassen",
    "duplicate": "Dupliceren",
    "add-layout-blocks": "Lay-outblokken toevoegen",
    "text": "Tekst",
    "image": "Afbeelding",
    "video": "Video",
    "new-name": "Nieuwe naam",
    "published": "Gepubliceerd",
    "all": "Alle",
    "editing": "Bezig met bewerken",
    "show-more": "Meer weergeven",
    "loading": "Bezig met laden",
    "or": "Of",
    "browse-files": "Bestanden doorzoeken",
    "edit": "Bewerken",
    "customize": "Aanpassen",
    "clear": "Wissen",
    "label": "Label",
    "discard-changes": "Wijzigingen verwerpen",
    "uploading": "Bezig met uploaden...",
    "preset": "Voorinstelling",
    "custom": "Aangepast",
    "manage": "Beheren",
    "done": "Klaar",
    "reminder": "Herinnering",
    "collections": "Collecties",
    "all-products": "Alle producten",
    "select": "Selecteren",
    "search": "Zoeken",
    "select-all": "Alles selecteren",
    "size-chart": "Maattabel",
    "continue": "Doorgaan",
    "back": "Terug",
    "visual-measurement-builder": "Visuele metingbouwer",
    "recommend": "Aanbevelen",
    "creating...": "Bezig met maken...",
    "syncing": "Bezig met synchroniseren...",
    "preview": "Voorbeeld",
    "create": "Maken",
    "onboarding": "Onboarding",
    "english": "English",
    "french": "Français",
    "spanish": "Español",
    "czech": "Čeština",
    "danish": "Dansk",
    "german": "Deutsch",
    "italian": "Italiano",
    "dutch": "Nederlands",
    "japanese": "Japans",
    "off": "Uit",
    "basic": "Basis",
    "AI": "AI",
    "details": "Details",
    "date": "Datum",
    "billing": "Facturering",
    "settings": "Instellingen",
    "log-out": "Uitloggen",
    "plan": "Abonnement",
    "ai-size-recommendation": "AI-maataanbeveling",
    "recommendations": "Aanbevelingen",
    "features": "Functies",
    "stock-notification": "Voorraadmelding",
    "published-size-charts": "Gepubliceerde maattabellen",
    "published-table-charts": "Gepubliceerde roostertabellen",
    "unlimited": "Onbeperkt",
    "x-of-y": "{{ x }} van {{ y }}",
    "measurements": "Metingen",
    "selected": "Geselecteerd",
    "select-product": "Product selecteren",
    "price": "Prijs",
    "title": "Titel",
    "message": "Bericht",
    "add": "Toevoegen",
    "remove": "Verwijderen",
    "cm": "cm",
    "in": "inch",
    "usd": "USD",
    "return": "Terug",
    "next": "Volgende",
    "store": "Winkel",
    "type": "Type",
    "cost": "Kosten",
    "incurred-at": "Gemaakt op",
    "search-placeholder": "Zoeken...",
    "more": "Meer...",
    "load-more": "Meer laden...",
    "status": "Status",
    "enabled": "Ingeschakeld",
    "disabled": "Uitgeschakeld",
    "total": "Totaal",
    "un-listed": "Niet vermeld",
    "global": "Globaal",
    "store-specific": "Winkelspecifiek",
    "ai-measurement-import": "Maten importeren met AI",
    "included": "Inbegrepen",
    "not-included": "Niet inbegrepen"
  },
  "snackbar": {
    "successfully-updated-your-preferences": "Je voorkeuren zijn succesvol bijgewerkt",
    "failed-to-update-your-preferences": "Bijwerken van je voorkeuren mislukt"
  },
  "import": {
    "upload-file": "Bestand uploaden",
    "sheet-import": {
      "title": "Maten uploaden vanuit een bestand",
      "dropzone": {
        "title": "Sleep een bestand hierheen",
        "accepted-types": "{{types}} – één bestand tegelijk",
        "browse": "Bestanden bladeren"
      },
      "hint": "Beste resultaten: één tabel waarvan de maatlabels overeenkomen met de varianten van deze maattabel, met kopteksten in de eerste rij of kolom. Maak een foto of screenshot scherp en recht van voren, en snijd alles behalve de tabel weg.",
      "example": {
        "caption": "Voorbeeld van een geaccepteerde indeling:",
        "size": "Maat",
        "chest": "Borst (cm)",
        "waist": "Taille (cm)"
      },
      "error": {
        "invalid-type": "Dit bestandstype wordt niet ondersteund. Upload een van deze: {{types}}.",
        "heic-unsupported": "HEIC-foto’s (het iPhone-formaat) worden niet ondersteund. Exporteer de foto als JPG of PNG en upload dat bestand.",
        "file-too-large": "Dit bestand is te groot. De maximale grootte is {{maxSizeMb}} MB."
      },
      "submit": "Uploaden en wijzigingen controleren",
      "running": {
        "this-chart": "Er loopt al een import voor deze maattabel.",
        "other-chart": "Er loopt al een import voor een andere maattabel. Er kan maar één import tegelijk lopen.",
        "open-import": "Import bekijken"
      },
      "accepted-files-tooltip": "Geaccepteerde bestanden: {{types}}",
      "button": {
        "importing": "Importeren… {{progress}}%",
        "review": "Import controleren"
      }
    }
  },
  "size-recommender": {
    "form": {
      "title": "Vind je beste maat",
      "subtitle": "Enkele snelle details voor een betere pasvorm",
      "shopping-for": "SHOPPEN VOOR",
      "women": "Dames",
      "men": "Heren",
      "other": "Anders",
      "measurements": "METINGEN",
      "height": "Lengte",
      "height-required": "Lengte is verplicht",
      "min-height": "Minimale lengte is 1",
      "weight": "Gewicht",
      "weight-required": "Gewicht is verplicht",
      "min-weight": "Minimaal gewicht is 1",
      "preferred-fit": "Voorkeurspasvorm"
    },
    "result": {
      "suggested-size": "Voorgestelde maat:",
      "no-fit": "Helaas lijkt het erop dat we op dit moment geen ideale maat hebben. We raden aan later terug te komen voor meer opties.",
      "verdict": "Oordeel:",
      "similar-variants": "Vergelijkbare varianten:",
      "proceed": "Doorgaan met deze variant",
      "estimate-disclaimer": "(Schatting gebaseerd op merk en gebruikersinformatie, resultaten kunnen variëren.)"
    },
    "ai": {
      "upgrade-title": "Upgrade je abonnement om AI-maataanbeveling te ontgrendelen",
      "upgrade-description": "Een functie die je klanten helpt om elke keer de juiste maat te vinden. Onze AI analyseert productdetails en klantinvoer om gepersonaliseerde maatsuggesties te geven, zodat kopers vol vertrouwen kopen en jij minder retouren en ruilingen ziet. Upgrade nu om deze ervaring in je winkel aan te bieden.",
      "image-alt": "Maataanbeveling",
      "upgrade-enable": "Nu upgraden en inschakelen",
      "explore-plans": "Andere abonnementen bekijken",
      "failed-load-recommendations": "Aanbevelingen konden niet worden geladen",
      "failed-fetch-plans": "Abonnementen konden niet worden opgehaald",
      "form-tab": "Formulier",
      "result-tab": "Resultaat"
    },
    "basic": {
      "measurements-required-title": "Voeg eerst maten toe",
      "measurements-required-description": "Basis maatadvies koppelt kopers aan een maat op basis van de maten in deze tabel. Voeg maten toe aan de tabel en zet het daarna aan."
    }
  },
  "chart-limit": {
    "title-size": "Je hebt je limiet voor gepubliceerde maattabellen bereikt",
    "title-table": "Je hebt je limiet voor gepubliceerde roostertabellen bereikt",
    "description-size": "Met je abonnement kun je {{limit}} maattabellen publiceren en je hebt er {{usage}} gepubliceerd. Deze tabel is als concept bewaard. Upgrade om meer te publiceren, of zet een tabel die je niet meer nodig hebt offline.",
    "description-table": "Met je abonnement kun je {{limit}} roostertabellen publiceren en je hebt er {{usage}} gepubliceerd. Deze tabel is als concept bewaard. Upgrade om meer te publiceren, of zet een tabel die je niet meer nodig hebt offline.",
    "upgrade-plan": "Abonnement upgraden",
    "explore-plans": "Abonnementen bekijken",
    "failed-fetch-plans": "Abonnementen konden niet worden geladen. Probeer het opnieuw.",
    "image-alt": "Tabelillustratie",
    "onboarding-saved-as-draft": "Je tabel is als concept opgeslagen, omdat de limiet voor gepubliceerde tabellen van je abonnement is bereikt. Je kunt hem publiceren na een upgrade of nadat je een andere tabel offline hebt gezet."
  },
  "help-centre": "Helpcentrum",
  "dimension-inputs": {
    "add-measurement": "Meting toevoegen"
  },
  "variant-editor": {
    "option-name": "Optienaam",
    "option-values": "Optiewaarden",
    "option-placeholder": "Maat / Kleur / Stof",
    "add-option": "Nog een optie toevoegen"
  },
  "dimension": {
    "shoulder": "Schouder",
    "bust": "Buste",
    "waist": "Taille",
    "arm": "Arm",
    "sleeve": "Mouw",
    "hip": "Heup",
    "crotch": "Kruis",
    "leg": "Been",
    "thigh": "Dij",
    "length": "Lengte",
    "bottom_width": "Onderbreedte",
    "chest": "Borst",
    "inside_leg": "Binnenbeenlengte",
    "back_length": "Ruglengte",
    "front_length": "Voorlengte",
    "front_rise": "Voorstuk",
    "back_rise": "Achterstuk",
    "leg_opening": "Beenopening",
    "overbust": "Bovenbuste",
    "underbust": "Onderbuste",
    "groups": {
      "tops": "Bovenkleding",
      "bottoms": "Onderkleding",
      "generals": "Algemeen"
    }
  },
  "analytic": {
    "range": {
      "1m": "1 maand",
      "3m": "3 maanden",
      "6m": "6 maanden",
      "1y": "1 jaar"
    }
  },
  "store-history": {
    "a-restore-is-already-running-for-this-store": "Er loopt al een herstel voor deze winkel. Wacht tot het klaar is en probeer opnieuw.",
    "a-snapshot-is-taken-only-on-days-you-change-something": "Er wordt alleen een back-up gemaakt op dagen dat je iets wijzigt.",
    "actor": {
      "merchant": "jij",
      "support": "Goodchart-support",
      "system": "Shopify"
    },
    "billing-plan-login-and-connected-integrations-are-not-touched": "Je facturatie, abonnement, login en gekoppelde integraties blijven ongemoeid.",
    "blocked": {
      "entity-exists": "Al opnieuw aangemaakt — herstel in plaats daarvan",
      "entity-missing": "Bestaat niet meer — herstel in plaats daarvan",
      "unsupported": "Kan niet ongedaan worden gemaakt — herstel in plaats daarvan",
      "value-changed": "Sindsdien gewijzigd — herstel in plaats daarvan"
    },
    "changes": "Wijzigingen",
    "discard-unsaved-changes": "Niet-opgeslagen wijzigingen verwerpen?",
    "dont-ask-again-in-this-session": "Niet meer vragen tijdens deze sessie",
    "earlier": "Eerder",
    "history": "Geschiedenis",
    "history-starts-from-your-first-snapshot": "De geschiedenis begint bij je eerste back-up",
    "label": {
      "category-created": "Categorie {{name}} aangemaakt",
      "category-deleted": "Categorie {{name}} verwijderd",
      "category-updated": "Categorie {{name}} bewerkt",
      "chart-created": "Maattabel {{name}} aangemaakt",
      "chart-deleted": "Maattabel {{name}} verwijderd",
      "chart-updated": "Maattabel {{name}} bewerkt",
      "dimension-created": "Maat {{name}} aangemaakt",
      "dimension-deleted": "Maat {{name}} verwijderd",
      "dimension-updated": "Maat {{name}} bewerkt",
      "draft-assignment-rules": "Toewijzingsregels gewijzigd",
      "draft-edited": "Tabel bewerkt",
      "draft-guide": "Meetgids bewerkt",
      "draft-labels": "Maatlabels bewerkt",
      "draft-measurements": "Maten bewerkt",
      "draft-model": "Modelmaten gewijzigd",
      "draft-publication": "Publicatie gewijzigd",
      "draft-renamed": "Tabel hernoemd",
      "draft-size-recommender": "Maatadvies gewijzigd",
      "draft-variants": "Varianten bewerkt",
      "keyword-created": "Trefwoord {{name}} aangemaakt",
      "keyword-deleted": "Trefwoord {{name}} verwijderd",
      "keyword-updated": "{{count}} trefwoorden bewerkt",
      "products-assigned": "{{count}} producten toegewezen",
      "profile-updated": "Winkelprofiel bijgewerkt",
      "store-restored": "Winkel hersteld naar {{date}}",
      "table-chart-created": "Tabel {{name}} aangemaakt",
      "table-chart-deleted": "Tabel {{name}} verwijderd",
      "table-chart-updated": "Tabel {{name}} bewerkt"
    },
    "no-changes-since-then": "Sindsdien geen wijzigingen.",
    "no-snapshots-yet": "Nog geen back-ups",
    "nothing-created-since-then-will-be-deleted": "Er wordt niets verwijderd dat sindsdien is aangemaakt.",
    "plus-x-more": "+{{x}} meer",
    "reloading-the-dashboard": "Dashboard wordt opnieuw geladen…",
    "restore": "Herstellen",
    "restore-confirmation-word": "HERSTELLEN",
    "restore-instead": "Herstel in plaats daarvan",
    "restore-your-store": "Je winkel herstellen",
    "restoring-your-store-do-not-close-this-window": "Je winkel wordt hersteld. Sluit dit venster niet.",
    "since-the-x-snapshot": "Sinds de back-up van {{x}}",
    "snapshots": "Back-ups",
    "the-change-was-undone-but-the-page-could-not-refresh": "De wijziging is ongedaan gemaakt, maar deze pagina kon niet vernieuwen. Herlaad om het te zien.",
    "this-backup-predates-image-protection": "Deze back-up dateert van vóór de beveiliging van afbeeldingen, dus sindsdien verwijderde afbeeldingen zijn niet terug te halen.",
    "this-changes-what-shoppers-see-on-your-product-pages-within-seconds": "Dit verandert binnen enkele seconden wat klanten op je productpagina’s zien.",
    "this-changes-what-shoppers-see-right-away": "Dit verandert meteen wat klanten zien.",
    "this-puts-your-store-back-to-how-it-was-on-x": "Hiermee gaat je winkel terug naar hoe die was op {{x}}.",
    "this-reverses-x-actions-up-to-and-including-y": "Dit maakt {{x}} acties ongedaan, tot en met ‘{{y}}’.",
    "trigger": {
      "daily": "Dagelijks",
      "install": "Bij installatie van Goodchart",
      "manual": "Handmatig (support)",
      "migration": "Eerste back-up",
      "pre-restore": "Voor herstel",
      "reinstall": "Bij herinstallatie van Goodchart"
    },
    "type-x-to-confirm": "Typ {{x}} om te bevestigen",
    "undid-x": "‘{{x}}’ ongedaan gemaakt",
    "undo-a-saved-change": "Een opgeslagen wijziging ongedaan maken",
    "undo-to-here": "Tot hier ongedaan maken",
    "undo-x-saved-y": "‘{{x}}’ ongedaan maken, opgeslagen {{y}}?",
    "unsaved": "Niet opgeslagen",
    "we-could-not-load-your-history": "We konden je geschiedenis niet laden.",
    "we-could-not-load-your-snapshots": "We konden je back-ups niet laden.",
    "we-could-not-restore-your-store": "We konden je winkel niet herstellen.",
    "we-could-not-work-out-what-would-change": "We konden niet bepalen wat er zou veranderen.",
    "we-take-a-snapshot-of-your-current-store-first-so-this-can-be-undone": "We maken eerst een back-up van je huidige winkel, zodat dit ongedaan te maken is.",
    "we-take-a-snapshot-of-your-store-each-day-it-changes": "We maken elke dag dat je winkel verandert een back-up. Je geschiedenis verschijnt hier zodra de eerste is gemaakt.",
    "what-comes-back": "Wat terugkomt",
    "what-is-lost": "Wat verloren gaat",
    "working-out-what-would-change": "Bezig met bepalen wat er zou veranderen…",
    "x-assignments": "{{x}} koppelingen",
    "x-charts": "{{x}} maattabellen",
    "x-images-cannot-be-brought-back": "{{x}} afbeeldingen kunnen niet worden teruggehaald — ze zijn meer dan 37 dagen geleden verwijderd.",
    "x-images-could-not-be-recovered": "{{x}} afbeeldingen konden niet worden hersteld — ze zijn meer dan 37 dagen geleden verwijderd.",
    "x-items-created-since-then-will-be-deleted": "{{x}} sindsdien aangemaakte items worden verwijderd, waaronder:",
    "x-items-will-be-recreated": "Er worden {{x}} items opnieuw aangemaakt.",
    "x-no-longer-exists-after-the-undo": "‘{{x}}’ bestaat niet meer na het ongedaan maken.",
    "x-table-charts": "{{x}} tabellen",
    "you-have-unsaved-changes-to-x-undoing-will-discard-them": "Je hebt niet-opgeslagen wijzigingen in ‘{{x}}’. Ongedaan maken verwerpt ze.",
    "your-store-has-been-restored": "Je winkel is hersteld."
  },
  "chart-import": {
    "progress": {
      "stage": {
        "reading-file": "Je bestand lezen",
        "understanding-table": "De tabel begrijpen",
        "matching-measurements": "Maten koppelen",
        "building-chart": "Je maattabel maken"
      },
      "reconnecting": "Opnieuw verbinden – even geduld, je voortgang gaat niet verloren.",
      "keep-working": "Je kunt gewoon verder werken — we laten het je weten zodra het klaar is.",
      "cancel": "Import annuleren",
      "cancel-confirm": {
        "title": "Deze import annuleren?",
        "message": "Je geüploade bestand wordt verwijderd en deze import kan niet worden hervat.",
        "keep": "Blijven wachten",
        "discard": "Import annuleren"
      },
      "ready": {
        "title": "Maattabel klaar om te controleren",
        "action": "Wijzigingen controleren"
      }
    },
    "failure": {
      "unreadable-file": {
        "message": "Die foto was te wazig of te donker om te lezen. Een scherpere, goed belichte foto werkt het best."
      },
      "no-table-found": {
        "message": "We konden geen maattabel in dit bestand vinden."
      },
      "unsupported-layout": {
        "message": "De indeling van deze tabel kunnen we nog niet lezen."
      },
      "model-timeout": {
        "message": "Dat duurde te lang – meestal is dit een tijdelijk probleem."
      },
      "internal": {
        "message": "Er ging bij ons iets mis bij het importeren van je maattabel."
      },
      "action": {
        "retry": "Opnieuw proberen",
        "try-another-photo": "Andere foto proberen",
        "try-another-file": "Ander bestand proberen",
        "other-methods": "Andere methoden"
      }
    },
    "diff-review": {
      "title": "Wijzigingen controleren",
      "subtitle": "Vink uit wat je niet op deze maattabel wilt toepassen.",
      "load-error": "We konden de wijzigingen voor deze import niet laden.",
      "no-changes": "Er zijn geen maten gewijzigd.",
      "grid": {
        "variant": "Maat",
        "dimension": "Maat",
        "old-value": "Huidig",
        "new-value": "Nieuw"
      },
      "unmatched-variants": "Maten in het bestand die niet overeenkomen met deze maattabel:",
      "unmapped-dimensions": "Kolommen die we niet aan een maat konden koppelen:",
      "apply": {
        "button": "Wijzigingen toepassen ({{count}})",
        "success": "Maattabel bijgewerkt ({{count}} wijzigingen toegepast)",
        "generic-error": "We konden deze wijzigingen niet toepassen. Probeer het opnieuw."
      },
      "cancel": {
        "button": "Import annuleren"
      }
    },
    "review": {
      "cancel-confirm": {
        "title": "Deze import annuleren?",
        "message": "Je geüploade bestand en je wijzigingen worden verwijderd. Deze import kan niet worden hervat.",
        "keep": "Verder controleren",
        "discard": "Import annuleren"
      }
    },
    "page": {
      "title": "Maten importeren",
      "empty": {
        "title": "Er loopt geen import voor deze maattabel",
        "message": "Upload een spreadsheet of een foto van een maattabel om de maten van deze maattabel bij te werken."
      }
    },
    "upgrade": {
      "title": "Maten importeren met AI",
      "description": "Upload een spreadsheet of een foto van een maattabel en wij vullen de maten van deze tabel voor je in. Maten importeren met AI zit niet in je huidige abonnement. Upgrade om het te gebruiken.",
      "upgrade-plan": "Abonnement upgraden",
      "explore-plans": "Abonnementen bekijken",
      "failed-fetch-plans": "Abonnementen konden niet worden geladen. Probeer het opnieuw.",
      "image-alt": "Illustratie van een maattabel"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday",
      "chip": "Black Friday-prijs",
      "popup": {
        "eyebrow": "Black Friday · Cyber Monday",
        "headline": "Tot {{percent}}% korting",
        "subheadline": "op Goodchart-abonnementen",
        "body": "Maak je maattabellen klaar voor de drukste week van het jaar. Duidelijke maten betekenen minder \"past dit?\"-vragen en minder retouren.",
        "feature-recommender": "AI-maatadvies dat elke klant de juiste maat voorstelt",
        "feature-import": "AI-import die een bestand of afbeelding omzet in een maattabel",
        "feature-analytics": "Analyses van hoe klanten je maattabellen gebruiken",
        "cta": "Bekijk de aanbiedingen",
        "later": "Misschien later"
      },
      "show-offer": "Black Friday-aanbieding bekijken"
    },
    "every-plan": "{{percent}}% korting op elk abonnement",
    "up-to": "Tot {{percent}}% korting",
    "switch-to": "Overstappen naar ${{price}}/{{interval}}",
    "switch-from": "Je hebt {{name}} voor ${{price}}/{{interval}}. Dezelfde functies, {{percent}}% goedkoper.",
    "switch-note-monthly": "Shopify vraagt je de nieuwe prijs goed te keuren en crediteert de rest van deze maand.",
    "switch-note-annual": "Shopify vraagt je de nieuwe prijs goed te keuren, die ingaat bij je verlenging op {{date}}.",
    "switch-note-annual-undated": "Shopify vraagt je de nieuwe prijs goed te keuren, die ingaat bij je volgende verlenging."
  },
  "agent-chat": {
    "open": "Supportchat openen",
    "close": "Supportchat sluiten",
    "expand": "Chat vergroten",
    "collapse": "Chat verkleinen",
    "title": "Goodchart-support",
    "history": "Gesprekken",
    "back": "Terug naar het gesprek",
    "new": "Nieuw gesprek",
    "placeholder": "Stel een vraag over Goodchart",
    "send": "Versturen",
    "welcome": "Hallo! Vraag me alles over Goodchart: maattabellen instellen, de maatgids in je winkel of je abonnement.",
    "history-empty": "Nog geen gesprekken.",
    "unread": "Nieuw antwoord",
    "you": "Jij",
    "merchant": "Verkoper",
    "assistant": "Goodchart-assistent",
    "team": "Goodchart-team",
    "typing": "Aan het schrijven…",
    "used-articles": "Beantwoord met de helpartikelen",
    "retry": "Opnieuw proberen",
    "activity": {
      "articles": "Leest de helpartikelen…",
      "store": "Bekijkt je winkel…",
      "code": "Controleert hoe Goodchart werkt…",
      "team": "Geeft dit door aan het Goodchart-team…"
    },
    "error": {
      "rate-limited": "Je verstuurt snel berichten. Probeer het over {{seconds}} seconden opnieuw. Heb je het Goodchart-team nodig, vraag me er dan om zodra je weer kunt sturen.",
      "daily-cap": "Je hebt de berichtenlimiet van vandaag bereikt. Probeer het morgen opnieuw en vraag me dan om het Goodchart-team als je het nog nodig hebt.",
      "disabled": "De supportassistent is momenteel niet beschikbaar.",
      "reply-failed": "Het antwoord is niet aangekomen.",
      "unknown": "Er is iets misgegaan."
    },
    "placeholder-team": "Voeg details toe voor het Goodchart-team",
    "unavailable": "De supportassistent is momenteel niet beschikbaar en neemt geen nieuwe vragen aan. Gesprekken die het Goodchart-team al heeft, blijven open in je geschiedenis.",
    "waiting": {
      "title": "Wachten op het Goodchart-team.",
      "body": "Ze antwoorden hier en je krijgt een melding. Je kunt intussen details toevoegen."
    },
    "starters": {
      "create-chart": "Hoe maak ik een maattabel?",
      "no-chart": "Welke van mijn producten hebben geen maattabel?",
      "not-showing": "Waarom wordt mijn maattabel niet getoond in mijn winkel?",
      "charts-left": "Hoeveel tabellen kan ik nog publiceren?"
    },
    "feedback": {
      "helpful": "Nuttig",
      "not-helpful": "Niet nuttig",
      "thanks": "Bedankt voor je feedback.",
      "comment-placeholder": "Wat klopte er niet of ontbrak er? (optioneel)",
      "send": "Versturen",
      "skip": "Overslaan",
      "rated-up": "Beoordeeld als nuttig",
      "rated-down": "Beoordeeld als niet nuttig"
    }
  }
}
